(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3152],{

/***/ 62532:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/setup",
      function () {
        return __webpack_require__(52257);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84538:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/11.86026da2.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42hXKvUrDUBiH8f97zkmkxhowIDi6qYOL4uzQrYsiuHsJ3oIX4OwmuDm5GDq6OHgDFR1rIygFrW1jkvPxvm2f9ffQ6f3oQhN1Y4XSM5QVgQAcESUskhti7tYsZ4UXZIbQUgABqBmIFEH1p1V5mDIudyI7rutw3UnD7UlmD9KA91lVGuusshY4P9rSnd223mjHEBEUfw3WOSi1px16xRRvwwmWuKz/McHj9wyb5KD+m4YzeHz9VsF5Dq+DcbjqDcI2eVQLM87ZBES4e/mMb56HePhx2F9Rek3TYpDEgDlvBHgaubJFUMerGo6ZrUdChHwOGAl8LfDGLzAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 79711:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/15.e11c799e.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42mMQXfVXZNVfydV/OVf9ZVjwh2HhH+nVIBEGgUW/RBb/Yl30S33Jr9Xnfy8584dhwS+Jxb8YuGZ8VZv1laHry46LP////7vr4k+GqV/FZ35l4O35KNv3kaHtw+2nv64//sVQ+0G5/yNXz0cG+eY3DMWvTl///v//PyA6d/M7Q8lrOaAgZ9lzhtLnrk0v7j/98fDZD+v6Fwwlz7mBggxZj1UKnjA4PLh06+vVO18ZnB4AuUBBBobkB/LpDxlc7l29/fXG3a8MrvfkgNzkBwAlaHR/cn2xQAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 69489:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/16.b0f4cb05.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42mOAgfvRAbF3woPW3wkJWH8/2juWARnc9HebecfX8f9DZ4H/D5yY/t+ysPh/Xcd5JkR2eVbsumSn/4+SQv+cX334z7n1h/68nBf4580c4/9fNrrEMDCszlsfN8Hx/4llB/+4z/3/X3fiv/8PLh768/8i4/+/Z3zWM6gtyljPsND7/4K9x/7kTvr337Xn7/+75w7/+X+e+/+fs0AFGguTYhjmR/8PXJX7Z8a+Y3/m7Tr65+f5iD//z1r+/3PGLQbsDMX5cTMF5oX/Z5ju9H//JrX//89b/P99GuJIBJgXHxMwO3b9txM+6/+fc42BCQMALP+AFtMto2sAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 57614:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/17.5c307e48.svg","height":44,"width":44});

/***/ }),

/***/ 49967:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/18.74eca1d7.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5klEQVR42lWPO2sCQRSFJ2XqFGmENIEkViH/LKQKIUiKEIL/QRufpZbrzAjjG5TVRt1xBV18oOiAIMIyxXFmC8ELt7nnnnPvR2wBeFFSCi+b07aVnAg7u4hzShWLPaP3nUAv8QP+EMecMhUtWSd/esWy2QpnjoNFrY6N64Y8/gabRMaZrHZ//7BsNBDwKtj9I7aDAfr/SXhGIzJf0J33D5uAQxCA3cawG47Q/fyCZzSiJr6ghFhHeFyvsWp3TBIPKbmD8n0RPTktldUwlYYhACU30ZmAcXVFctrvxcypaFkoauO8YJ4BYV21J40VIu8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 4201:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/19.a0fb6d13.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA3ElEQVR42kWPPUsDQRiE7yf5j+ys7JQt/Q2ChaTRKmKbC4nRSpAVFCURREQLCxNC7iu3e/vuXjb3ZvJxJBmYZp4pZoKttLVCM8uNy1LU6R6GKo6Q3d8h6XYxHY6QF0VYQ7JiDaPjI59eNdjcXLL7fPWFI0zTTAS5W0j73YZ/POdkBvQGJTovxH//CmSUDPSqoH7a+B1cMBHw/Fbi4Iz4qa8wn+UyIGNFnMU4bJ34hrzm2/cmnza/fBQbGJPVY6mgcJJG6Hw8oNXvYZwMQfXIvUgbUbm5rFwlSbvdzSWzoLMLtNFDUQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 59535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/19.5679bc9c.webp","height":500,"width":500,"blurDataURL":"data:image/webp;base64,UklGRrgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDUAAAABYFTbtpL7fyJcE8EMIvjoJxYOFiIiwipZllRWA8CoFLyHbMWDZ9//ZwneQ60JYJZR51wvAwBWUDggXAAAABACAJ0BKggACAACQDglqAJ0bX8Cf/ZavwAA/uF7p+CX9JNUfAujS/l7nzfxrUS6AJ+/N8rDpz09Xa6EmSKsOH87DcKQIfs9z/+qEaDn6QY+1IVdsn6sw23bG5gA","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 88101:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/21.fbc5244f.webp","height":256,"width":256,"blurDataURL":"data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAAAwAgCdASoIAAgAAkA4JbACdG1/AvJ6mk/kgAD+9V8xK7aNYidyuvn2g0ZxDfaWrvhjbNtsMcz9wVv2LPD535g3rjPftuXRF31f2Gv1gPnwBy+s6/Jv5y/5UQAAAA==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 95598:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/22.88cba043.webp","height":190,"width":190,"blurDataURL":"data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACwAQCdASoIAAgAAkA4JaQAAud7cY6AAP7903IdG/csJky5UrmwLHI9itWZzYdZAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 47234:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/7.c1a6ff67.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAzElEQVR42mN4oKXKyIADwOWeG2iJPVVXMHtub23x3Nvd4qmGotlzfU0xsOQtDWWOBxrKNx4a6Py/z8AAxg/1tf8/0FS5cUtNiYPhiqqy/HVdnS9XgRJvjxz582D+/D8g9nUdrS9X1FTkGY7JKcidUdP4foqB4f/jTZv+3+jr+w9in1FV+w6SY1guKs56QFTq5EFF1f/7GBj+gPBBBZX/B8SkT64QFmVlAIFOCRmulQxMyht8/FTXe3iprmRgU+4RleICS+4Rl8HmTbgcAIKzT0pjg1p+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 47206:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/8.59b9a5ea.jpg","height":180,"width":180,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAAkQn/AP/EAB4QAAEEAQUAAAAAAAAAAAAAAAIBAwQSEQAFBmKi/9oACAEBAAE/ABDZYvHnHLtSJckGsIpJdg0UrYHr61//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/AFtP/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQARcf/aAAgBAwEBPwBArJ//2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 52257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ setup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 10 modules
var es_carousel = __webpack_require__(91978);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
;// CONCATENATED MODULE: ./src/components/android-step/newFooter.js




const NewFooter = (param)=>{
    let { nowPage , setNowPage , startMonitoring , showFlag =false , setIsAgree  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-[75px] flex justify-center items-center [border-top:1px_solid_#E5E7EB] absolute bottom-0 cursor-pointer bg-[#FFFFFF] ".concat(showFlag ? "hidden" : "", " select-none z-[52]"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full lg:w-[620px] flex ".concat(nowPage === 17 ? "justify-center" : "justify-between"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-max flex p-[6px_19px_6px_10px] [border:1px_solid_#454CFF] smj:ml-[16px] rounded-[18px] ".concat(nowPage === 17 ? "hidden" : ""),
                    onClick: ()=>{
                        if (nowPage === 1) setNowPage(0);
                        else if (nowPage === 0) window.location.assign((0,resolveCurrentOrderId/* appendSetupQuery */.Rb)("/android/classification"));
                        else setNowPage(nowPage - 1);
                        if (nowPage === 12) setNowPage(3);
                        if (nowPage === 3) setNowPage(0);
                        if (nowPage === 16) setNowPage(14);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/bind/bind-arrow-blue.svg",
                            width: 18,
                            height: 18,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[15px] text-[#454CFF] font-[600] leading-[22px] ml-[7px]",
                            children: t("BACK")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-max flex p-[6px_19px_6px_10px] bg-[#FFCF55] smj:mr-[16px] pl-[24px] pr-[10px] rounded-[18px] ".concat([
                        1,
                        12,
                        17
                    ].includes(nowPage) ? "hidden" : ""),
                    onClick: ()=>{
                        if (nowPage !== 12) setNowPage(nowPage + 1);
                        if (nowPage === 3) setNowPage(12);
                        if (nowPage === 0) setNowPage(3);
                        if (nowPage === 14) setNowPage(16);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[15px] text-[#1B1C2B] font-[600] leading-[22px] mr-[6px]",
                            children: t("NEXT")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/bind/bind-arrow-black.svg",
                            width: 18,
                            height: 18,
                            alt: ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-max flex bg-[#FFCF55] smj:mr-[16px] px-[19px] py-[7px] rounded-[18px] ".concat(nowPage !== 12 || nowPage === 17 ? "hidden" : ""),
                    onClick: startMonitoring,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-[14px] text-[#1B1C2B] font-[600] leading-[22px]",
                        children: [
                            t("Start monitoring"),
                            " "
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[130px] flex justify-center items-center p-[7px_19px_7px_10px] bg-[#FFCF55] px-[19px] rounded-[18px] ".concat(nowPage !== 17 ? "hidden" : "", " text-nowrap"),
                    onClick: ()=>{
                        setTimeout(()=>{
                            window.location.assign("/");
                        }, 1500);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[14px] text-[#1B1C2B] font-[600] leading-[22px]",
                        children: t("Complete")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var newFooter = (NewFooter);

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./src/components/android-step/one.js








const ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
function One(data) {
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const step = [
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Go to the <p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Play Store</p>.</div>"),
            img: "/images/android/one/1.png"
        },
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Tap on<p style='font-weight: 600;margin-left: 5px;display: inline-block;'>the profile icon</p><p style='display: inline-block;margin: 0 5px;'>or</p><p style='display: inline-block;font-weight: 600;margin-right: 5px;'>the three dots</p>in the top right corner. </div>"),
            img: "/images/android/one/2.png"
        },
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Find and tap <p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Play Protect</p>.</div>"),
            img: "/images/android/one/3.png"
        },
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Tap on<p style='font-weight: 600;margin:0px 5px;display: inline-block;'>Settings</p>(gear icon) in the top right corner.</div>"),
            img: "/images/android/one/4.png"
        },
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Turn off<p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Scan apps with Play Protect</p>.</div>"),
            img: "/images/android/one/5.png"
        },
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Tap<p style='font-weight: 600;margin:0px 5px;display: inline-block;'>Turn off</p> in pop-up.</div>"),
            img: "/images/android/one/6.png"
        }
    ];
    const imgToggle = (0,react.useRef)();
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    const onChange = (currentSlide1)=>{
        setcurrentSlide(currentSlide1);
    };
    const Handler = (index)=>{
        if (index !== 6) {
            imgToggle.current.goTo(index);
        } else {
            imgToggle.current.goTo(0);
        }
    };
    const [autoplay, setAutoplay] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        const handleClick = (event)=>{
            if (window.innerWidth < 600) {
                setAutoplay(false);
                setTimeout(()=>{
                    setAutoplay(true);
                }, [
                    5000
                ]);
            }
        };
        // 添加点击事件监听器
        document.addEventListener("click", handleClick);
        // 添加滑动事件监听器
        document.addEventListener("scroll", handleClick);
        // 在组件卸载时移除事件监听器
        return ()=>{
            document.removeEventListener("click", handleClick);
            document.removeEventListener("scroll", handleClick);
        };
    }, [
        autoplay
    ]) // 空数组表示只在组件加载和卸载时运行
    ;
    const StepProgress = (param)=>{
        let { current =1 , total =6  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollDiv, {
                className: "w-[620px] Ssm:w-[100%] mx-auto overflow-x-hidden justify-between setup ".concat(data.fullScreen ? "flex justify-center xs:pb-[10px]" : " Smd:flex xs:pb-[70px] h-[99%]", " overflow-auto pb-[88px] h-full p-[0px_15px_15px_15px] max-w-[1440px]"),
                children: [
                    data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                        onClick: ()=>{
                            data.setFullScreen(false);
                        },
                        icon: "maki:cross",
                        className: "absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "Ssm:w-[100%] w-full mx-auto setup ".concat(data.fullScreen ? "grid mx-auto h-full justify-center" : "Smd:flex Dsm:mt-[0px] justify-between"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[343px] ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[24px] Dsm:text-[20px] pb-[10px] font-[600] text-[#2B2D33] Dsm:text-center  ".concat(data.fullScreen ? "hidden" : ""),
                                        children: t("Disable Play Protect on the device you want to monitor")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onMouseEnter: ()=>{
                                            if (window.innerWidth > 600) {
                                                setAutoplay(false);
                                            }
                                        },
                                        onMouseLeave: ()=>{
                                            if (window.innerWidth > 600) {
                                                setAutoplay(true);
                                            }
                                        },
                                        className: "pl-1 ".concat(data.fullScreen ? "pt-[20px]" : "Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]"),
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: ()=>Handler(index),
                                                className: "flex text-[14px] cursor-pointer text-black ".concat(data.fullScreen ? "mt-[10px]" : " mt-[7px] Dsm:mt-[10px]"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "w-[24px] h-[22px] rounded-full flex items-center justify-center mt-[2px] ".concat(currentSlide === index && "bg-[#2A99FF] text-white"),
                                                        children: [
                                                            index + 1,
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-1 w-[100%] mt-[2px] ".concat(data.fullScreen ? "text-[15px]" : "text-[15px]"),
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.title
                                                        }
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-white p-3 mt-6 flex items-start rounded-[8px] [box-shadow:0px_1px_6px_0px_#28293826] ".concat(data.fullScreen && "mb-[138px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/warn.svg",
                                                width: 24,
                                                height: 24,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "ml-3 text-[14px] leading-[22px] text-[#282938]",
                                                children: t("The app comes from the trusted developer but Google Play may temporarily block it for universal protection Please disable this setting to install the app smoothly")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] relative border-[#ACB1BD] ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_carousel/* default */.Z, {
                                        waitForAnimate: true,
                                        autoplay: autoplay,
                                        className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                        ref: imgToggle,
                                        cancelable: false,
                                        afterChange: onChange,
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    alt: "img",
                                                    width: 100,
                                                    height: 100,
                                                    src: item.img,
                                                    className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center mt-5",
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>Handler(index),
                                                className: "border-[1px] ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute -left-[4px] top-[55px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px]",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px] mt-4",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden", " mb-[65px]"),
                        onClick: ()=>data.setFullScreen(true),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/bind/watch.svg",
                                width: 100,
                                height: 100,
                                alt: "img",
                                className: "mx-auto w-[58px] mt-[36px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                                children: t("Watch a tutorial")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: data.nowPage,
                setNowPage: data.setNowPage,
                startMonitoring: data.startMonitoring
            })
        ]
    });
}
/* harmony default export */ var one = (One);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
;// CONCATENATED MODULE: ./src/components/android-step/two.js











function two_One(data) {
    const { t  } = useTranslation("commonAndroid");
    const step = [
        {
            title: t("Open a browser (Chrome, Firefox, or any other browser)."),
            img: [
                {
                    src: "/images/android/two/1.jpg"
                }
            ]
        },
        {
            title: t("Copy or type the link below into the address bar or scan the QR code to go to the download page."),
            img: [
                {
                    src: "/images/android/two/2.png"
                }
            ]
        },
        {
            title: t("<div style='display: inline-block;'>Check the <p style='font-weight: 600;margin:0 5px;display: inline-block;'> I'm not a robot </p> checkbox, pass the<p style='font-weight: 600;display: inline-block;margin:0 5px;'> captcha,  </p> and click <p style='font-weight: 600;margin:0 5px;display: inline-block;'> Download </p> once it's complete. If you see a warning pop-up, press <p style='font-weight: 600;display: inline-block;'> Download anyway.</p></div>"),
            img: [
                {
                    src: "/images/android/two/3.jpg"
                }
            ]
        },
        {
            title: t("<div style='display: inline-block;'>After the download is complete, tap <p style='font-weight: 600;margin-right:5px;display: inline-block;'> Open.</p>If you see a warning pop-up, press <p style='font-weight: 600;display: inline-block;'> Settings</p>, look for your browser, and <p style='font-weight: 600;display: inline-block;'> turn the setting on</p>. Then press <p style='font-weight: 600;display: inline-block;'> Install</p>.</div>"),
            img: [
                {
                    src: "/images/android/two/4.png"
                },
                {
                    src: "/images/android/two/4.1.png"
                },
                {
                    src: "/images/android/two/4.2.png"
                },
                {
                    src: "/images/android/two/4.3.png"
                }
            ]
        },
        {
            title: t("<div style='display: inline-block;'>After installing the application, press <p style='font-weight: 600;display: inline-block;'> Open</p>. If you see a security pop-up, hit <p style='font-weight: 600;margin-right:5px;display: inline-block;'> IGNORE</p>.</div>"),
            img: [
                {
                    src: "/images/android/two/5.png"
                }
            ]
        }
    ];
    const imgToggle = useRef();
    const [currentSlide, setcurrentSlide] = useState(0);
    const [carousel, setCarousel] = useState(step[0].img);
    const [autoplay, setAutoplay] = useState(true);
    const Handler = (index)=>{
        if (index !== 6) {
            setCarousel(step[index].img);
            setcurrentSlide(index);
            setImg(0);
            imgToggle.current.goTo(0);
        /* imgToggle.current.goTo(index) */ } else {
            /* imgToggle.current.goTo(0) */ setCarousel(step[index].img);
            setcurrentSlide(index);
        }
    };
    const { query  } = useRouter();
    const [a, setA] = useState(1);
    useEffect(()=>{
        const interval = setInterval(()=>{
            if (autoplay === true) {
                if (parseInt(currentSlide) === 4) {
                    setCarousel(step[0].img);
                    setcurrentSlide(0);
                    setImg(0);
                    imgToggle.current.goTo(0);
                } else {
                    setCarousel(step[currentSlide + 1].img);
                    setcurrentSlide(currentSlide + 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        }, [
            parseInt(currentSlide) !== 3 ? 4000 : 11000
        ]);
        // 清除定时器以避免内存泄漏
        return ()=>clearInterval(interval);
    }, [
        currentSlide,
        carousel,
        query,
        a,
        autoplay
    ]);
    const [Img, setImg] = useState(0);
    useEffect(()=>{
        let startX;
        const handleTouchStart = (e)=>{
            // 记录触摸起始位置
            startX = e.touches[0].clientX;
        };
        const handleTouchMove = (e)=>{
            // 计算触摸移动距离
            e.preventDefault();
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            // 根据 deltaX 判断左右滑动
            if (deltaX > 0) {
                if (parseInt(currentSlide) === 0) {
                    setCarousel(step[4].img);
                    setcurrentSlide(4);
                    setImg(0);
                } else {
                    setCarousel(step[currentSlide - 1].img);
                    setcurrentSlide(currentSlide - 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            } else if (deltaX < 0) {
                if (parseInt(currentSlide) === 3) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[currentSlide + 1].img);
                        setcurrentSlide(currentSlide + 1);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    }
                } else if (parseInt(currentSlide) === 4) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[0].img);
                        setcurrentSlide(0);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    }
                } else {
                    setcurrentSlide(currentSlide + 1);
                    setCarousel(step[currentSlide + 1].img);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        };
        // 添加事件监听器
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        // 清理工作
        return ()=>{
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        currentSlide,
        carousel,
        query,
        a,
        Img
    ]);
    const [copy, setCopy] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const success = ()=>{
        messageInfo({
            type: "success",
            content: "Copied"
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-[620px] Ssm:w-[100%] overflow-x-hidden overflow-auto h-[100%] mx-auto justify-between setup ".concat(data.fullScreen ? "grid xs:pb-[0px]" : "Smd:flex overflow-hidden xs:pb-[70px] h-[99%]"),
        children: [
            contextHolder,
            data.fullScreen && /*#__PURE__*/ _jsx(Icon, {
                onClick: ()=>{
                    data.setFullScreen(false);
                },
                icon: "maki:cross",
                className: "absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
            }),
            /*#__PURE__*/ _jsxs("div", {
                onMouseEnter: ()=>{
                    setAutoplay(false), setA(0);
                },
                onMouseLeave: ()=>{
                    setAutoplay(true), setA(1);
                },
                className: "w-full text-black Ssm:w-[100%] mx-auto justify-between setup ".concat(data.fullScreen ? "grid mx-auto" : " Smd:flex Dsm:mt-[30px] justify-between"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[343px] ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] Dsm:text-center  ".concat(data.fullScreen ? "hidden" : ""),
                                children: t("Download Msafely installer on the target phone")
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "pl-1 ".concat(data.fullScreen ? "pt-[20px]" : "Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]"),
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ _jsxs("div", {
                                        onClick: ()=>Handler(index),
                                        className: " text-[14px] cursor-pointer  ".concat(data.fullScreen ? "mt-[10px]" : " mt-[7px] Dsm:mt-[10px]"),
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        className: "w-[24px] h-[22px] rounded-full flex items-center justify-center -mt-[1px] ".concat(currentSlide === index && "bg-[#12D8AB] text-white"),
                                                        children: [
                                                            index + 1,
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "ml-1 w-[100%]  ".concat(data.fullScreen ? "text-[13px]" : "text-[13px]"),
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.title
                                                        }
                                                    })
                                                ]
                                            }),
                                            index === 1 && /*#__PURE__*/ _jsxs("div", {
                                                className: "mt-2 pb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Image, {
                                                        width: 100,
                                                        height: 100,
                                                        src: "https://image.msafely.com/20231103/msafely_apk_19dbb61286.png",
                                                        className: "w-[97px] h-[97px] mx-auto",
                                                        alt: "code"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "bg-[#F0F3F4] rounded-md p-2 flex items-center w-[200px] justify-between mx-auto mt-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Image, {
                                                                width: 100,
                                                                height: 100,
                                                                src: "/images/android/browser.svg",
                                                                className: "w-[16px] h-[16px]",
                                                                alt: "browser"
                                                            }),
                                                            /*#__PURE__*/ _jsx(CopyToClipboard, {
                                                                text: "https://msafely.net/download",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    onClick: ()=>{
                                                                        setCopy(!copy), success();
                                                                    },
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("p", {
                                                                            className: "text-[11px] text-[#676CF6] text-center flex items-center justify-center mr-3",
                                                                            children: "https://msafely.net/download"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Icon, {
                                                                            icon: copy ? "healthicons:yes" : "solar:copy-line-duotone",
                                                                            className: "w-[18px] h-[18px] text-[#676CF6]"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                        children: [
                            /*#__PURE__*/ _jsx(Carousel, {
                                autoplay: autoplay,
                                className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                ref: imgToggle,
                                cancelable: false,
                                afterChange: (index)=>{},
                                beforeChange: (index, index2)=>{
                                    setImg(index2);
                                },
                                children: carousel.map((item, index)=>{
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "rounded-[15px]",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            alt: "img",
                                            width: 100,
                                            height: 100,
                                            src: item.src,
                                            className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-center justify-center mt-5",
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ _jsx("div", {
                                        onClick: ()=>{
                                            setCarousel(step[index].img), setcurrentSlide(index), setImg(0), imgToggle.current.goTo(0);
                                        },
                                        className: "border-[1px] border-[#12D8AB] w-[12px] h-[12px] cursor-pointer rounded-[15px] ".concat(index !== 0 && "ml-2", " ").concat(currentSlide === index && "bg-[#12D8AB]", " ")
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "absolute -left-[4px] top-[55px]",
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/android/1.svg",
                                        className: "w-[5px] h-[24px]",
                                        width: 100,
                                        height: 100,
                                        alt: "img"
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/android/1.svg",
                                        className: "w-[5px] h-[24px] mt-4",
                                        width: 100,
                                        height: 100,
                                        alt: "img"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "Smd:hidden ".concat(data.fullScreen && "hidden"),
                onClick: ()=>data.setFullScreen(true),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: "/images/android/watch.png",
                    width: 100,
                    height: 100,
                    alt: "watch",
                    className: "mx-auto w-[150px] mt-[20px]"
                })
            })
        ]
    });
}
/* harmony default export */ var two = ((/* unused pure expression or super */ null && (two_One)));

;// CONCATENATED MODULE: ./src/components/android-step/three.js







function three_One(data) {
    const { t  } = useTranslation("commonAndroid");
    const step = [
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Go to the <p style='font-weight: 600;margin-left: 5px;display: inline-block;'>'Play Store'</p>.</div>"),
            img: "/images/android/three/1.png"
        }
    ];
    const imgToggle = useRef();
    const [currentSlide, setcurrentSlide] = useState(0);
    const onChange = (currentSlide1)=>{
        setcurrentSlide(currentSlide1);
    };
    const Handler = (index)=>{
        if (index !== 6) {
            imgToggle.current.goTo(index);
        } else {
            imgToggle.current.goTo(0);
        }
    };
    const [autoplay, setAutoplay] = useState(true);
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-[620px] Ssm:w-[100%] mx-auto justify-between overflow-x-hidden overflow-auto setup ".concat(data.fullScreen ? "flex xs:pb-[20px] justify-center" : " Smd:flex xs:pb-[30px] h-[99%]"),
        children: [
            data.fullScreen && /*#__PURE__*/ _jsx(Icon, {
                onClick: ()=>{
                    data.setFullScreen(false);
                },
                icon: "maki:cross",
                className: " absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
            }),
            /*#__PURE__*/ _jsxs("div", {
                onMouseEnter: ()=>{
                    setAutoplay(false);
                },
                onMouseLeave: ()=>{
                    setAutoplay(true);
                },
                className: "Ssm:w-[100%] w-full mx-auto setup ".concat(data.fullScreen ? "grid mx-auto justify-center" : " Smd:flex Dsm:mt-[80px] Dsm:xs:mt-[30px] justify-between"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[343px] ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] text-center Smd:text-left  text-black ".concat(data.fullScreen ? "hidden" : ""),
                                children: t("Install Msafely")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "".concat(data.fullScreen ? "pt-[15px]" : "Dsm:pt-[20px] Dsm:w-[96%] mx-auto"),
                                children: [
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "text-[#222] text-[13px] mt-3 Ssm:text-center",
                                        children: [
                                            t("Enter the registration code"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-[#2ECC71] text-[42px] font-[700] mt-3 Ssm:text-center",
                                        children: data.Code
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-[#222] text-[13px] mt-3 Ssm:text-center",
                                        children: t("Follow the instructions you see on the target Android phone")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                        children: [
                            /*#__PURE__*/ _jsx(Carousel, {
                                autoplay: autoplay,
                                className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                ref: imgToggle,
                                cancelable: false,
                                afterChange: onChange,
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: " rounded-[15px]",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            alt: "img",
                                            width: 100,
                                            height: 100,
                                            src: item.img,
                                            className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-center justify-center mt-5",
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ _jsx("div", {
                                        onClick: ()=>Handler(index),
                                        className: "border-[1px] ml-2 border-[#12D8AB] w-[12px] h-[12px] cursor-pointer rounded-[15px] ".concat(currentSlide === index && "bg-[#12D8AB]", " ")
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "absolute -left-[3px] top-[55px]",
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/android/1.svg",
                                        className: "w-[5px] h-[24px]",
                                        width: 100,
                                        height: 100,
                                        alt: "img"
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/android/1.svg",
                                        className: "w-[5px] h-[24px] mt-4",
                                        width: 100,
                                        height: 100,
                                        alt: "img"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "Smd:hidden ".concat(data.fullScreen && "hidden"),
                onClick: ()=>data.setFullScreen(true),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: "/images/android/watch.png",
                    width: 100,
                    height: 100,
                    alt: "watch",
                    className: "mx-auto w-[150px] mt-[20px]"
                })
            })
        ]
    });
}
/* harmony default export */ var three = ((/* unused pure expression or super */ null && (three_One)));

;// CONCATENATED MODULE: ./src/components/android-step/four.js









const four_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
function four_One(data) {
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const step = [
        {
            title: "<div style='line-height: 20px;'>Go to the<p style='font-weight: 600;display: inline-block;margin:0 3px;'>browser </p>you used to download Msafely <p style='font-family: Arial;margin-right:3px;display: inline-block;font-size: 16px;'>→</p> tap the<p style='font-weight: 600;display: inline-block;margin:0 5px;'>three dots</p>in the top right corner<p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;'>Settings </p>(gear icon).</div>",
            img: [
                {
                    src: "/images/android/four/1.png"
                },
                {
                    src: "/images/android/four/1-1.png"
                }
            ]
        },
        {
            title: "<div style='line-height: 20px;'>Go to<p style='font-weight: 600;display: inline-block;margin:0 3px;'>Privacy and Security</p><p style='font-family: Arial;margin-right:3px;display: inline-block;font-size: 16px;'>→</p> tap the<p style='font-weight: 600;display: inline-block;'>Clear browsing data</p><p style='font-family: Arial;margin:0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;'>Clear data </p>.</div>",
            img: [
                {
                    src: "/images/android/four/2.png"
                },
                {
                    src: "/images/android/four/2-2.png"
                },
                {
                    src: "/images/android/four/2-3.png"
                }
            ]
        },
        {
            title: "<div style='line-height: 20px;'>Go to<p style='font-weight: 600;display: inline-block;margin:0 5px'>home screen</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin:0 5px'>swipe up</p>to open apps,find and tap<p style='font-weight: 600;display: inline-block;margin:0 5px'>My Files</p>.</div>",
            img: [
                {
                    src: "/images/android/four/3.png"
                }
            ]
        },
        {
            title: "<div style='line-height: 20px;'>Go to <p style='font-weight: 600;display: inline-block;margin:0 5px'>Downloads</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p>long tap on<p style='font-weight: 600;display: inline-block;margin-right:5px'>Update service</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin:0 5px'>Delete all</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin-right:5px'>Move to trash</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin:0 5px'>Back</p>.</div>",
            img: [
                {
                    src: "/images/android/four/4.png"
                },
                {
                    src: "/images/android/four/4-1.png"
                },
                {
                    src: "/images/android/four/4-2.png"
                }
            ]
        },
        {
            title: "<div style='line-height: 20px;'>Tap the<p style='font-weight: 600;display: inline-block;margin:0 5px'>three dots</p>in the top right corner<p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin:0 5px'>Trash</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p>long tap on<p style='font-weight: 600;display: inline-block;margin:0 5px'>Update service<p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin:0 5px'>Delete all</p><p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin-left:5px'> Delete</p>.</div>",
            img: [
                {
                    src: "/images/android/four/5.png"
                },
                {
                    src: "/images/android/four/5-1.png"
                },
                {
                    src: "/images/android/four/5-2.png"
                },
                {
                    src: "/images/android/four/5-3.png"
                }
            ]
        }
    ];
    const imgToggle = (0,react.useRef)();
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    const [carousel, setCarousel] = (0,react.useState)(step[0].img);
    const [autoplay, setAutoplay] = (0,react.useState)(true);
    const Handler = (index)=>{
        if (index !== 6) {
            setCarousel(step[index].img);
            setcurrentSlide(index);
            setImg(0);
            imgToggle.current.goTo(0);
        /* imgToggle.current.goTo(index) */ } else {
            /* imgToggle.current.goTo(0) */ setCarousel(step[index].img);
            setcurrentSlide(index);
        }
    };
    const { query  } = (0,next_router.useRouter)();
    const [a, setA] = (0,react.useState)(1);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (autoplay === true) {
                if (parseInt(currentSlide) === 4) {
                    setCarousel(step[0].img);
                    setcurrentSlide(0);
                    setImg(0);
                    imgToggle.current.goTo(0);
                } else {
                    setCarousel(step[currentSlide + 1].img);
                    setcurrentSlide(currentSlide + 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        }, [
            parseInt(currentSlide) === 2 ? 4000 : parseInt(currentSlide) === 4 ? 11000 : parseInt(currentSlide) === 0 ? 7000 : parseInt(currentSlide) === 1 ? 8000 : parseInt(currentSlide) === 4 ? 8000 : 8000
        ]);
        // 清除定时器以避免内存泄漏
        return ()=>clearInterval(interval);
    }, [
        currentSlide,
        carousel,
        query,
        a,
        autoplay
    ]);
    const [Img, setImg] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        let startX;
        const handleTouchStart = (e)=>{
            // 记录触摸起始位置
            startX = e.touches[0].clientX;
        };
        const handleTouchMove = (e)=>{
            // 计算触摸移动距离
            e.preventDefault();
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            // 根据 deltaX 判断左右滑动
            if (deltaX > 0) {
                if (parseInt(currentSlide) === 0) {
                    if (parseInt(Img) === 0 && parseInt(Img + 1) !== carousel.length) {
                        setCarousel(step[4].img);
                        setcurrentSlide(4);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    } else {
                        setImg(0);
                    }
                } else {
                    setCarousel(step[currentSlide - 1].img);
                    setcurrentSlide(currentSlide - 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            } else if (deltaX < 0) {
                if (parseInt(currentSlide) === 0 || parseInt(currentSlide) === 1 || parseInt(currentSlide) === 3) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[currentSlide + 1].img);
                        setcurrentSlide(currentSlide + 1);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    }
                } else if (parseInt(currentSlide) === 4) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[0].img);
                        setcurrentSlide(0);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    }
                } else {
                    setcurrentSlide(currentSlide + 1);
                    setCarousel(step[currentSlide + 1].img);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        };
        // 添加事件监听器
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        // 清理工作
        return ()=>{
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        currentSlide,
        carousel,
        query,
        a,
        Img
    ]);
    const StepProgress = (param)=>{
        let { current =4 , total =6  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(four_ScrollDiv, {
                className: "w-[620px] Ssm:w-[100%] mx-auto justify-between overflow-x-hidden setup overflow-auto pb-[132px] h-full p-[0px_15px_15px_15px] max-w-[1440px]",
                children: [
                    data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                        onClick: ()=>{
                            data.setFullScreen(false);
                        },
                        icon: "maki:cross",
                        className: " absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseEnter: ()=>{
                            setAutoplay(false), setA(0);
                        },
                        onMouseLeave: ()=>{
                            setAutoplay(true), setA(1);
                        },
                        className: "w-full text-black Ssm:w-[100%] mx-auto setup ".concat(data.fullScreen ? "grid mx-auto justify-center" : "Smd:flex justify-between"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[343px] ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[24px] Dsm:text-[20px] pb-[10px] font-[600] Dsm:text-center  ".concat(data.fullScreen ? "hidden" : ""),
                                        children: t("Clear traces")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pl-1 pt-2 text-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[16px]",
                                                children: t("Clear Browsing Data")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "1.\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Open the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("browser")
                                                            }),
                                                            " ",
                                                            t("app you used to download Msafely"),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "2."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Navigate to"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Settings")
                                                            }),
                                                            " (",
                                                            t("typically located in the top-right or bottom-right corner of the screen"),
                                                            ")."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "3."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Select the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Privacy and security")
                                                            }),
                                                            " ",
                                                            t("option"),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "4."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Tap"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Clear Browsing data")
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-[16px] mt-[50px]",
                                                children: [
                                                    t("Clear Downloaded APK"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "1.\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Return to the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Home screen")
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "2."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Swipe up and open the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Apps drawer")
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "3."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Search for and open the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("My Files or Files")
                                                            }),
                                                            " ",
                                                            t("app"),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "4."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Within Files select the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Downloads")
                                                            }),
                                                            " ",
                                                            t("folder"),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "5."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Long-press the file named"),
                                                            ' "',
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: "app-spyx"
                                                            }),
                                                            '", ',
                                                            t("then tap"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Move to Trash")
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "6."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("Return to the main My Files interface locate and open the"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("Trash")
                                                            }),
                                                            " (",
                                                            t("or Recycle Bin"),
                                                            ")."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "pr-2",
                                                        children: "7."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            t("In the Trash confirm and"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t("permanently delete")
                                                            }),
                                                            " ",
                                                            t("the app-spyx file"),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_carousel/* default */.Z, {
                                        autoplay: autoplay,
                                        className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                        waitForAnimate: false,
                                        ref: imgToggle,
                                        cancelable: false,
                                        afterChange: (index)=>{},
                                        beforeChange: (index, index2)=>{
                                            setImg(index2);
                                        },
                                        children: carousel.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " rounded-[15px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    alt: "img",
                                                    width: 100,
                                                    height: 100,
                                                    src: item.src,
                                                    className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center mt-5",
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>{
                                                    setCarousel(step[index].img), setcurrentSlide(index), setImg(0), imgToggle.current.goTo(0);
                                                },
                                                className: "border-[1px]  ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute -left-[3px] top-[55px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px]",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px] mt-4",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden"),
                        onClick: ()=>data.setFullScreen(true),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/bind/watch.svg",
                                width: 100,
                                height: 100,
                                alt: "watch",
                                className: "mx-auto w-[58px] mt-[36px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                                children: t("Watch a tutorial")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: data.nowPage,
                setNowPage: data.setNowPage,
                startMonitoring: data.startMonitoring
            })
        ]
    });
}
/* harmony default export */ var four = (four_One);

;// CONCATENATED MODULE: ./src/components/android-step/five.js










const five_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
function five_One(data) {
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const step = [
        {
            title: t("<div style='line-height: 20px;'><p style='font-weight: 600;display: inline-block;margin-right:3px;'>Pull down</p>the extended menu from the top of the screen.</div>"),
            img: [
                {
                    src: "/images/android/five/1.png"
                }
            ]
        },
        {
            title: t("<div style='line-height: 20px;'><p style='font-weight: 600;display: inline-block;margin-right:3px;'>Pull down again</p>until you see<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Location,</p>&nbsp;then<p style='font-weight: 600;display: inline-block;margin-left:3px;'>enable Location.</p></div>"),
            img: [
                {
                    src: "/images/android/five/2.png"
                },
                {
                    src: "/images/android/five/2.1.png"
                }
            ]
        }
    ];
    const imgToggle = (0,react.useRef)();
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    const [carousel, setCarousel] = (0,react.useState)(step[0].img);
    const [autoplay, setAutoplay] = (0,react.useState)(true);
    const Handler = (index)=>{
        if (index !== 6) {
            setCarousel(step[index].img);
            setcurrentSlide(index);
            setImg(0);
            imgToggle.current.goTo(0);
        /* imgToggle.current.goTo(index) */ } else {
            /* imgToggle.current.goTo(0) */ setCarousel(step[index].img);
            setcurrentSlide(index);
        }
    };
    const { query  } = (0,next_router.useRouter)();
    const [a, setA] = (0,react.useState)(1);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (autoplay === true) {
                if (parseInt(currentSlide) === 1) {
                    setCarousel(step[0].img);
                    setcurrentSlide(0);
                    setImg(0);
                    imgToggle.current.goTo(0);
                } else if (parseInt(currentSlide) === 0) {
                    setCarousel(step[currentSlide + 1].img);
                    setcurrentSlide(currentSlide + 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        }, [
            parseInt(currentSlide) !== 1 ? 3000 : 6000
        ]);
        // 清除定时器以避免内存泄漏
        return ()=>clearInterval(interval);
    }, [
        currentSlide,
        carousel,
        query,
        a,
        autoplay
    ]);
    const [Img, setImg] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        let startX;
        const handleTouchStart = (e)=>{
            // 记录触摸起始位置
            startX = e.touches[0].clientX;
        };
        const handleTouchMove = (e)=>{
            // 计算触摸移动距离
            e.preventDefault();
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            // 根据 deltaX 判断左右滑动
            if (deltaX > 0) {
                if (parseInt(currentSlide) === 1) {
                    if (parseInt(Img) === 0 && parseInt(Img + 1) !== carousel.length) {
                        setCarousel(step[0].img);
                        setcurrentSlide(0);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    } else {
                        setImg(0);
                    }
                } else if (parseInt(currentSlide) === 0) {
                    /* setcurrentSlide(currentSlide + 1)
          setCarousel(step[currentSlide + 1].img)
          setcurrentSlide2(0) */ setCarousel(step[1].img);
                    setcurrentSlide(1);
                    setImg(0);
                }
            } else if (deltaX < 0) {
                if (parseInt(currentSlide) === 1) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[0].img);
                        setcurrentSlide(0);
                        setImg(0);
                    }
                } else if (parseInt(currentSlide) === 0) {
                    setcurrentSlide(1);
                    setCarousel(step[1].img);
                    imgToggle.current.goTo(0);
                }
            }
        };
        // 添加事件监听器
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        // 清理工作
        return ()=>{
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        currentSlide,
        carousel,
        query,
        a,
        Img
    ]);
    const StepProgress = (param)=>{
        let { current =5 , total =6  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(five_ScrollDiv, {
                className: "w-[620px] Ssm:w-[100%] mx-auto justify-between setup overflow-auto pb-[132px] h-full p-[0px_15px_15px_15px] max-w-[1440px]",
                children: [
                    data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                        onClick: ()=>{
                            data.setFullScreen(false);
                        },
                        icon: "maki:cross",
                        className: " absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseEnter: ()=>{
                            setAutoplay(false), setA(0);
                        },
                        onMouseLeave: ()=>{
                            setAutoplay(true), setA(1);
                        },
                        className: "w-full text-black Ssm:w-[100%] mx-auto setup ".concat(data.fullScreen ? "grid mx-auto justify-center" : " Smd:flex justify-between"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[343px] ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[24px] Dsm:text-[20px] pb-[10px] font-[600] Ssm:text-center  ".concat(data.fullScreen ? "hidden" : ""),
                                        children: t("Turn on Location")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pl-1 ".concat(data.fullScreen ? "pt-[20px]" : "Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]"),
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>Handler(index),
                                                className: "flex text-[14px] cursor-pointer  ".concat(data.fullScreen ? "mt-[10px]" : " mt-[7px] Dsm:mt-[10px]"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "w-[24px] h-[22px] rounded-full flex items-center justify-center ".concat(currentSlide === index && "bg-[#2A99FF] text-white"),
                                                            children: [
                                                                index + 1,
                                                                "."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "ml-1 w-[100%]  ".concat(data.fullScreen ? "text-[13px]" : "text-[13px]"),
                                                            dangerouslySetInnerHTML: {
                                                                __html: item.title
                                                            }
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_carousel/* default */.Z, {
                                        autoplay: autoplay,
                                        className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                        ref: imgToggle,
                                        cancelable: false,
                                        afterChange: (index)=>{},
                                        beforeChange: (index, index2)=>{
                                            setImg(index2);
                                        },
                                        children: carousel.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " rounded-[15px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    alt: "img",
                                                    width: 100,
                                                    height: 100,
                                                    src: item.src,
                                                    className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center mt-5",
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>{
                                                    setCarousel(step[index].img), setcurrentSlide(index), setImg(0), imgToggle.current.goTo(0);
                                                },
                                                className: "border-[1px] ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute -left-[3px] top-[55px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px]",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px] mt-4",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden"),
                        onClick: ()=>data.setFullScreen(true),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/bind/watch.svg",
                                width: 100,
                                height: 100,
                                alt: "watch",
                                className: "mx-auto w-[58px] mt-[36px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                                children: t("Watch a tutorial")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: data.nowPage,
                setNowPage: data.setNowPage,
                startMonitoring: data.startMonitoring
            })
        ]
    });
}
/* harmony default export */ var five = (five_One);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(74865);
// EXTERNAL MODULE: ./src/pages/appTimeline/index.js
var appTimeline = __webpack_require__(61502);
;// CONCATENATED MODULE: ./src/components/android-step/six.js












const six_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
function six_One(data) {
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const step = [
        {
            phone: [
                {
                    title: t("<div style='line-height: 20px;'>On the<p style='font-weight: 600;display: inline-block;margin:0 3px;'>home screen, swipe up</p>to open the menu and tap on the<p style='font-weight: 600;display: inline-block;margin:0 3px;'>three dots</p>in the top right corner<p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;display: inline-block;margin-left:3px;'>Settings</p>.</div>"),
                    img: [
                        {
                            src: "/images/android/six/1.png"
                        },
                        {
                            src: "/images/android/six/1.1.png"
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Find and tap<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Hide apps</p>.</div>"),
                    img: [
                        {
                            src: "/images/android/six/2.png"
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Find and select<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Update service</p>and hit<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Done</p>.</div>"),
                    img: [
                        {
                            src: "/images/android/six/3.png"
                        }
                    ]
                }
            ]
        },
        {
            phone: [
                {
                    title: t("<div style='line-height: 20px;'>Navigate to the app drawer on your Pixel device.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Press and hold the application you wish to hide.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>From the pop-up menu, tap on the info icon.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Hit the Disable application option.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                }
            ]
        },
        {
            phone: [
                {
                    title: t("<div style='line-height: 20px;'>Turn on the Motorola screen and unlock the device.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>From the home screen, tap and hold an application you wish to hide or remove.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Drag the application on the Remove section at the top of the interface to hide the application from the home screen.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                }
            ]
        },
        {
            phone: [
                {
                    title: t("<div style='line-height: 20px;'>Open Xiaomi device settings.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Tap \"App lock\".</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Then tap \"Hidden apps.\"</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Tap \"Manage hidden apps\" and select the apps you wish to hide.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                }
            ]
        },
        {
            phone: [
                {
                    title: t("<div style='line-height: 20px;'>Launch the app drawer.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Use the swipe gesture to open the Hidden Space.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Hit the + menu on the top-right side.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Choose the apps you wish to hide.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                }
            ]
        },
        {
            phone: [
                {
                    title: t("<div style='line-height: 20px;'>Head over to Settings.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t('<div style=\'line-height: 20px;\'>Click on the "Display tab" and select "Home screen."</div>'),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>There is an option named \"Hide apps.\"</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                },
                {
                    title: t("<div style='line-height: 20px;'>Select the applications you wish to hide and then click Done.</div>"),
                    img: [
                        {
                            src: ""
                        }
                    ]
                }
            ]
        }
    ];
    const phone = [
        {
            name: "Samsung"
        },
        {
            name: "Pixel"
        },
        {
            name: "Motorola"
        },
        {
            name: "XiaoMi"
        },
        {
            name: "OnePlus"
        },
        {
            name: "LG"
        }
    ];
    //  const newsetp=
    const imgToggle = (0,react.useRef)();
    //说明处的步骤索引
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    //当前选择的手机类型
    const [phoneNum, setPhoneNum] = (0,react.useState)(0);
    const [carousel, setCarousel] = (0,react.useState)(step[0].phone[0].img);
    const [autoplay, setAutoplay] = (0,react.useState)(true);
    const [specificIndex, setSpecificIndex] = (0,react.useState)(currentSlide) // 你想访问的图片索引
    ;
    //点击步骤切换步骤和显示对应的图片
    const Handler = (index)=>{
        setCarousel(step[index].phone[index].img);
        setcurrentSlide(index);
        setImg(0);
        imgToggle.current.goTo(0);
    };
    const { query  } = (0,next_router.useRouter)();
    const [a, setA] = (0,react.useState)(1);
    (0,react.useEffect)(()=>{
        const intervalDuration = currentSlide !== 0 ? 3000 : 6000;
        const interval = setInterval(()=>{
            if (autoplay) {
                const nextSlide = (currentSlide + 1) % step[0].phone.length;
                setCarousel(step[0].phone[nextSlide].img);
                setcurrentSlide(nextSlide);
                setImg(0);
                imgToggle.current.goTo(0);
            }
        }, intervalDuration);
        return ()=>clearInterval(interval);
    }, [
        currentSlide,
        autoplay
    ]);
    const [Img, setImg] = (0,react.useState)(0);
    //选择手机类型
    const handelPhone = (i)=>{
        setPhoneNum(i);
        setcurrentSlide(0);
        setCarousel(step[i].phone.flatMap((item)=>item.img));
    };
    (0,react.useEffect)(()=>{
        let startX;
        const handleTouchStart = (e)=>{
            // 记录触摸起始位置
            startX = e.touches[0].clientX;
        };
        const handleTouchMove = (e)=>{
            // 计算触摸移动距离
            e.preventDefault();
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            // 根据 deltaX 判断左右滑动
            // 根据 deltaX 判断左右滑动
            if (deltaX > 0) {
                if (parseInt(currentSlide) === 0) {
                    if (parseInt(Img) === 0 && parseInt(Img + 1) !== carousel.length) {
                        setCarousel(step[0].phone[2].img) // 修改为访问第一种结构
                        ;
                        setcurrentSlide(2);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    } else {
                        setImg(0);
                    }
                } else {
                    setCarousel(step[0].phone[currentSlide - 1].img) // 修改为访问第一种结构
                    ;
                    setcurrentSlide(currentSlide - 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            } else if (deltaX < 0) {
                if (parseInt(currentSlide) === 0) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[0].phone[1].img) // 修改为访问第一种结构
                        ;
                        setcurrentSlide(1);
                        setImg(0);
                    }
                } else if (parseInt(currentSlide) === 2) {
                    setcurrentSlide(0);
                    setCarousel(step[0].phone[0].img) // 修改为访问第一种结构
                    ;
                    setImg(0);
                    imgToggle.current.goTo(0);
                } else {
                    setcurrentSlide(currentSlide + 1);
                    setCarousel(step[0].phone[currentSlide + 1].img) // 修改为访问第一种结构
                    ;
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        };
        // 添加事件监听器
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        // 清理工作
        return ()=>{
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        currentSlide,
        carousel,
        query,
        a,
        Img
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(six_ScrollDiv, {
                className: "w-[620px] Ssm:w-[100%] mx-auto justify-between setup ".concat(data.fullScreen ? "flex flex-col" : " Smd:flex", " overflow-auto pb-[88px] h-full p-[12px_15px_15px_15px] max-w-[1440px]"),
                children: [
                    data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                        onClick: ()=>{
                            data.setFullScreen(false);
                        },
                        icon: "maki:cross",
                        className: " absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseEnter: ()=>{
                            setAutoplay(false), setA(0);
                        },
                        onMouseLeave: ()=>{
                            setAutoplay(true), setA(1);
                        },
                        className: "w-full text-black Ssm:w-[100%] mx-auto justify-between items-start setup ".concat(data.fullScreen ? "flex flex-col mx-auto" : " Smd:flex Dsm:mt-[80px] Dsm:xs:mt-[30px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[343px] h-auto ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] Ssm:text-center  ".concat(data.fullScreen ? "hidden" : ""),
                                        children: t("Hide Msafely")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full ".concat(data.fullScreen ? "pt-[20px]" : "Dsm:pt-[5px] pt-[5px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "grid grid-cols-3 place-items-center w-full ".concat(data.fullScreen ? "gap-2" : "gap-4"),
                                                children: phone.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: ()=>handelPhone(index),
                                                        className: "w-[94px] h-[40px] text-[12px] rounded-[6px] hover:text-[#454CFF] ".concat(phoneNum === index ? "text-[#454CFF] bg-[#FFF]" : " text-[#9A9A9F] bg-[#F8F8F8] border-[1px] border-[#E5E7EB]"),
                                                        style: {
                                                            boxShadow: phoneNum === index ? "0px 0px 3px 0px #00000033" : "none"
                                                        },
                                                        children: item.name
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-[40px]",
                                                children: step[phoneNum].phone.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: ()=>Handler(index),
                                                        className: "flex text-[14px] cursor-pointer ".concat(data.fullScreen ? "mt-[10px]" : "mt-[7px] Dsm:mt-[10px]"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "w-[24px] h-[22px] rounded-full flex items-center justify-center ".concat(currentSlide === index && "bg-[#2A99FF] text-white"),
                                                                    children: [
                                                                        index + 1,
                                                                        "."
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "ml-1 w-[100%] ".concat(data.fullScreen ? "text-[13px]" : "text-[13px]"),
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: item.title
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }, index))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[220px] rounded-[24px] p-[6px] h-[506px] border-[1px] border-[#ACB1BD] relative ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_carousel/* default */.Z, {
                                        autoplay: autoplay,
                                        className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                        ref: imgToggle,
                                        cancelable: false,
                                        swipeToSlide: true,
                                        children: phoneNum === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: carousel.map((item, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " rounded-[15px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        alt: "img",
                                                        width: 100,
                                                        height: 100,
                                                        src: item.src,
                                                        className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                                    })
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center mt-5",
                                        children: step[phoneNum].phone.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>{
                                                    setCarousel(step[index].phone[index].img), setcurrentSlide(index), imgToggle.current.goTo(0);
                                                },
                                                className: "border-[1px] ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                            }, index))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute -left-[3px] top-[55px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px]",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px] mt-4",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden"),
                        onClick: ()=>data.setFullScreen(true),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/bind/watch.svg",
                                width: 100,
                                height: 100,
                                alt: "watch",
                                className: "mx-auto w-[58px] mt-[36px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                                children: t("Watch a tutorial")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: data.nowPage,
                setNowPage: data.setNowPage,
                startMonitoring: data.startMonitoring
            })
        ]
    });
}
/* harmony default export */ var six = (six_One);

;// CONCATENATED MODULE: ./src/components/android-step/seven.js









const seven_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
function seven_One(data) {
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const step = [
        {
            title: t("<div style='display: inline-block;line-height: 20px;'><p style='font-weight: 600;margin-right:5px;display: inline-block;'>Pull down</p>the extended menu from the top of the screen and<p style='font-weight: 600;margin-left: 5px;display: inline-block;'>tap Clear</p>.</div>"),
            img: "/images/android/seven/1.png"
        },
        {
            title: t("<div style='display: inline-block;line-height: 20px;'>Open the Recents screen by pressing the<p style='font-family: Arial;margin: 0 5px;display: inline-block;font-size: 16px;'>≡</p>button or by<p style='font-weight: 600;margin:0 5px;display: inline-block;'>swiping up</p>from the bottom of the screen<p style='font-family: Arial;margin: 0 3px;display: inline-block;font-size: 16px;'>→</p><p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Close all</p>.</div>"),
            img: "/images/android/seven/2.png"
        }
    ];
    const imgToggle = (0,react.useRef)();
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    const onChange = (currentSlide1)=>{
        setcurrentSlide(currentSlide1);
    };
    const Handler = (index)=>{
        if (index !== 6) {
            imgToggle.current.goTo(index);
        } else {
            imgToggle.current.goTo(0);
        }
    };
    const [autoplay, setAutoplay] = (0,react.useState)(true);
    const StepProgress = (param)=>{
        let { current =6 , total =6  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(seven_ScrollDiv, {
                className: "w-[620px] Ssm:w-[100%] mx-auto justify-between setup ".concat(data.fullScreen ? "grid" : " Smd:flex", " overflow-auto pb-[132px] h-full p-[0px_15px_15px_15px] max-w-[1440px]"),
                children: [
                    data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                        onClick: ()=>{
                            data.setFullScreen(false);
                        },
                        icon: "maki:cross",
                        className: " absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseEnter: ()=>{
                            setAutoplay(false);
                        },
                        onMouseLeave: ()=>{
                            setAutoplay(true);
                        },
                        className: "Ssm:w-[100%] text-black w-full mx-auto justify-between setup ".concat(data.fullScreen ? "grid mx-auto" : "Smd:flex"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[343px] ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%] Ssm:mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[24px] Dsm:text-[20px] pb-[10px] font-[600] Ssm:text-center ".concat(data.fullScreen ? "hidden" : ""),
                                        children: t("Final checkup")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pl-1 ".concat(data.fullScreen ? "pt-[20px]" : "Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]"),
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: ()=>Handler(index),
                                                className: "flex text-[14px] cursor-pointer  ".concat(data.fullScreen ? "mt-[10px]" : " mt-[7px] Dsm:mt-[10px]"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "w-[24px] h-[22px] rounded-full flex items-center justify-center mt-[2px] ".concat(currentSlide === index && "bg-[#2A99FF] text-white"),
                                                        children: [
                                                            index + 1,
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-1 w-[100%] mt-[2px] ".concat(data.fullScreen ? "text-[13px]" : "text-[13px]"),
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.title
                                                        }
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[220px] rounded-[24px] p-[6px] h-[506px] border-[1px] border-[#ACB1BD] relative  ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_carousel/* default */.Z, {
                                        autoplay: autoplay,
                                        className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                        ref: imgToggle,
                                        cancelable: false,
                                        afterChange: onChange,
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "rounded-[15px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    alt: "img",
                                                    width: 100,
                                                    height: 100,
                                                    src: item.img,
                                                    className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center mt-5",
                                        children: step.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>Handler(index),
                                                className: "border-[1px] ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute -left-[3px] top-[55px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px]",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/android/1.svg",
                                                className: "w-[5px] h-[24px] mt-4",
                                                width: 100,
                                                height: 100,
                                                alt: "img"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden"),
                        onClick: ()=>data.setFullScreen(true),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/bind/watch.svg",
                                width: 100,
                                height: 100,
                                alt: "watch",
                                className: "mx-auto w-[58px] mt-[36px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                                children: t("Watch a tutorial")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: data.nowPage,
                setNowPage: data.setNowPage,
                startMonitoring: data.startMonitoring
            })
        ]
    });
}
/* harmony default export */ var seven = (seven_One);

;// CONCATENATED MODULE: ./src/components/android-step/eight.js









const eight_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
function eight_One(data) {
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(eight_ScrollDiv, {
                className: "w-[620px] lg:mt-[40px] Ssm:w-[100%] mx-auto justify-between overflow-auto setup ".concat(data.fullScreen ? "grid overflow-hidden" : " Smd:flex h-full", " overflow-auto pb-[88px] h-full p-[12px_15px_15px_15px] max-w-[1440px]"),
                children: [
                    data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                        onClick: ()=>{
                            data.setFullScreen(false);
                        },
                        icon: "maki:cross",
                        className: " absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full Ssm:w-[100%] mx-auto justify-between items-start setup ".concat(data.fullScreen ? "grid mx-auto" : " Smd:flex"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[343px] mx-auto ".concat(data.fullScreen ? "order-2 w-[80%] mx-auto" : "Dsm:w-[100%]"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(data.fullScreen ? "pt-[15px]" : "Dsm:pt-[20px] Dsm:w-[96%] mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[129px] h-[129px] mx-auto flex justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "64",
                                            height: "120",
                                            viewBox: "0 0 64 120",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V110C64 115.523 59.5228 120 54 120H10C4.47715 120 0 115.523 0 110V10Z",
                                                    fill: "#2A313B"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M0 10C0 4.47716 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V44.9123L0 74.1053L0 10Z",
                                                    fill: "#3D4550"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M37.5943 57.475C37.5869 57.4731 37.5869 57.4657 37.5832 57.4565C37.3924 57.0616 37.0872 56.7333 36.7073 56.5143C36.3273 56.2952 35.8902 56.1957 35.4529 56.2286C34.8712 56.2808 34.3339 56.5609 33.958 57.0078C33.5821 57.4547 33.3982 58.0321 33.4464 58.6141C33.4742 58.9266 33.5574 59.2133 33.6924 59.474C33.9962 60.1771 34.0845 60.9546 33.9459 61.7078C33.8073 62.4611 33.4481 63.1562 32.9138 63.7051L27.0443 69.6745C25.5871 71.1539 23.2182 71.1539 21.7592 69.6745C20.3038 68.1951 20.3038 65.7911 21.7592 64.3098L23.9487 62.087L23.9357 62.0685C24.4406 61.6247 24.7346 60.9497 24.6828 60.2211C24.6624 59.9333 24.5855 59.6522 24.4564 59.3942C24.3273 59.1361 24.1485 58.906 23.9304 58.717C23.7122 58.5281 23.459 58.384 23.1851 58.2931C22.9112 58.2021 22.6221 58.166 22.3343 58.1869C21.7797 58.2295 21.263 58.4846 20.8919 58.8989L20.89 58.8952L18.658 61.1587C17.1344 62.7152 16.2812 64.8067 16.2812 66.9847C16.2812 69.1628 17.1344 71.2542 18.658 72.8108C19.4047 73.5752 20.2966 74.1826 21.2814 74.5972C22.2662 75.0119 23.324 75.2256 24.3925 75.2256C25.4611 75.2256 26.5188 75.0119 27.5036 74.5972C28.4884 74.1826 29.3804 73.5752 30.127 72.8108L36.0113 66.834C38.4782 64.3265 39.0108 60.615 37.6331 57.5693C37.6231 57.5373 37.6101 57.5045 37.5943 57.475ZM45.3482 46.2038C44.6015 45.4394 43.7096 44.8321 42.7248 44.4174C41.74 44.0027 40.6822 43.7891 39.6137 43.7891C38.5451 43.7891 37.4874 44.0027 36.5026 44.4174C35.5178 44.8321 34.6258 45.4394 33.8792 46.2038L27.9911 52.1806C25.5243 54.6845 24.9917 58.3959 26.3638 61.4398C26.3805 61.4712 26.3915 61.5045 26.4045 61.5396L26.4156 61.5581C26.8021 62.3459 27.6268 62.8563 28.5459 62.786C29.1276 62.7338 29.6649 62.4537 30.0408 62.0068C30.4167 61.5599 30.6006 60.9825 30.5524 60.4005C30.5267 60.1007 30.4432 59.8086 30.3064 59.5406C30.0023 58.8376 29.9139 58.06 30.0526 57.3067C30.1912 56.5534 30.5505 55.8582 31.0849 55.3095L36.9581 49.3438C37.3025 48.9927 37.7134 48.7138 38.1668 48.5233C38.6202 48.3329 39.1071 48.2348 39.5989 48.2348C40.0907 48.2348 40.5775 48.3329 41.031 48.5233C41.4844 48.7138 41.8953 48.9927 42.2396 49.3438C43.695 50.8214 43.695 53.2273 42.2396 54.7085L40.0538 56.9313L40.0723 56.9498C39.8134 57.1787 39.6111 57.4645 39.4811 57.7846C39.3512 58.1048 39.2972 58.4508 39.3233 58.7953C39.4177 60.0159 40.4699 60.9312 41.6719 60.8332C42.2451 60.7907 42.7481 60.5188 43.1143 60.1157L43.1161 60.1231L45.3482 57.8578C48.5104 54.6345 48.5104 49.416 45.3482 46.2038Z",
                                                    fill: "#12D8AB"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    x: "24.7012",
                                                    y: "112.281",
                                                    width: "15.7193",
                                                    height: "1.68421",
                                                    fill: "#8F98AF"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M17.4043 0H46.5973V2.73684C46.5973 4.94598 44.8064 6.73684 42.5973 6.73684H21.4043C19.1952 6.73684 17.4043 4.94598 17.4043 2.73684V0Z",
                                                    fill: "url(#paint0_linear_1316_865)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                    cx: "24.1404",
                                                    cy: "3.3689",
                                                    r: "1.12281",
                                                    fill: "#8F98AF"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "paint0_linear_1316_865",
                                                        x1: "32.0008",
                                                        y1: "0",
                                                        x2: "32.0008",
                                                        y2: "6.73684",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                "stop-color": "#353C4A"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#222A38"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[24px] text-[#292C33] Dsm:text-[24px] pb-[10px] font-[600] mt-[60px] Dsm:mt-[24px] text-center ".concat(data.fullScreen ? "hidden" : ""),
                                        children: t("Congratulations")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] text-black text-center mt-[24px]",
                                        children: t("Msafely was successfully installed")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-[600] mt-[30px] text-center text-black",
                                        children: t("You dont need the target phone anymore")
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: data.nowPage,
                setNowPage: data.setNowPage,
                startMonitoring: data.startMonitoring
            })
        ]
    });
}
/* harmony default export */ var eight = (eight_One);

;// CONCATENATED MODULE: ./src/components/android-step/PermissionDescription.js












const options = [
    {
        label: "Samsung/Google/Motorola/Others",
        value: "0"
    },
    {
        label: "XiaoMi",
        value: "1"
    }
];
function PermissionDescription_One(data) {
    const { t  } = useTranslation("commonAndroid");
    const [phoneModel, setPhoneModel] = useState("0");
    const step1 = useMemo(()=>[
            {
                title: t("Allow&nbsp;<strong>Appear on top</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/1.1.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Installed apps</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.1.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Update service</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.2.jpg"
                    }
                ]
            },
            {
                title: t("Turn on&nbsp;<strong>Update service</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.3.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Allow</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.4.jpg"
                    }
                ]
            },
            {
                title: t("Settings > Apps Settings > Apps > Manage apps (some models)"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.1.png"
                    }
                ]
            },
            {
                title: t("Find and Tap&nbsp;<strong>Update service</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.2.png"
                    }
                ]
            },
            {
                title: t("Tap on the 3 dots in the upper right corner"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.3.png"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Allow restricted settings</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.4.png"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Permissions</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/4.1.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Location > Allow all the time</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/4.2.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Activate</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/4.3.jpg"
                    }
                ]
            }
        ], [
        t
    ]);
    const step2 = useMemo(()=>[
            {
                title: t("Allow&nbsp;<strong>Appear on top</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/1.1.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Installed apps</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.1.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Update service</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.2.jpg"
                    }
                ]
            },
            {
                title: t("Turn on&nbsp;<strong>Update service</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.3.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Allow</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/3.4.jpg"
                    }
                ]
            },
            {
                title: t("Settings > Apps > Manage apps"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.1(xiaomi).jpg"
                    }
                ]
            },
            {
                title: t("Find and Tap&nbsp;<strong>Update service</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.2(xiaomi).jpg"
                    }
                ]
            },
            {
                title: t("Turn on&nbsp;<strong>Allow restricted settings</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.3(xiaomi).jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>No restrictions</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/2.4(xiaomi).jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Permissions</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/4.1.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Location > Allow all the time</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/4.2.jpg"
                    }
                ]
            },
            {
                title: t("Tap&nbsp;<strong>Activate</strong>"),
                img: [
                    {
                        src: "/images/android/permissiondescription/4.3.jpg"
                    }
                ]
            }
        ], [
        t
    ]);
    const [step, setStep] = useState(step1);
    const imgToggle = useRef();
    const [currentSlide, setcurrentSlide] = useState(0);
    const [carousel, setCarousel] = useState(step[0].img);
    const [autoplay, setAutoplay] = useState(true);
    useEffect(()=>{
        if (phoneModel === "0") {
            setStep(step1);
        } else {
            setStep(step2);
        }
        setCarousel(step[0].img);
        setcurrentSlide(0);
        setImg(0);
        imgToggle.current.goTo(0);
    }, [
        phoneModel,
        step,
        step1,
        step2
    ]);
    const Handler = (index)=>{
        if (index !== 13) {
            setCarousel(step[index].img);
            setcurrentSlide(index);
            setImg(0);
            imgToggle.current.goTo(0);
        /* imgToggle.current.goTo(index) */ } else {
            /* imgToggle.current.goTo(0) */ setCarousel(step[index].img);
            setcurrentSlide(index);
        }
    };
    const { query  } = useRouter();
    const [a, setA] = useState(1);
    useEffect(()=>{
        const interval = setInterval(()=>{
            if (autoplay === true) {
                if (parseInt(currentSlide) === 11) {
                    setCarousel(step[0].img);
                    setcurrentSlide(0);
                    setImg(0);
                    imgToggle.current.goTo(0);
                } else {
                    setCarousel(step[currentSlide + 1].img);
                    setcurrentSlide(currentSlide + 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        }, [
            parseInt(currentSlide) !== 11 ? 4000 : 11000
        ]);
        // 清除定时器以避免内存泄漏
        return ()=>clearInterval(interval);
    }, [
        currentSlide,
        carousel,
        query,
        a,
        autoplay
    ]);
    const [Img, setImg] = useState(0);
    useEffect(()=>{
        let startX;
        const handleTouchStart = (e)=>{
            // 记录触摸起始位置
            startX = e.touches[0].clientX;
        };
        const handleTouchMove = (e)=>{
            // 计算触摸移动距离
            e.preventDefault();
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            // 根据 deltaX 判断左右滑动
            if (deltaX > 0) {
                if (parseInt(currentSlide) === 0) {
                    setCarousel(step[11].img);
                    setcurrentSlide(11);
                    setImg(0);
                } else {
                    setCarousel(step[currentSlide - 1].img);
                    setcurrentSlide(currentSlide - 1);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            } else if (deltaX < 0) {
                if (parseInt(currentSlide) === 10) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[currentSlide + 1].img);
                        setcurrentSlide(currentSlide + 1);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    }
                } else if (parseInt(currentSlide) === 11) {
                    if (parseInt(Img) + 1 === carousel.length) {
                        setCarousel(step[0].img);
                        setcurrentSlide(0);
                        setImg(0);
                        imgToggle.current.goTo(0);
                    }
                } else {
                    setcurrentSlide(currentSlide + 1);
                    setCarousel(step[currentSlide + 1].img);
                    setImg(0);
                    imgToggle.current.goTo(0);
                }
            }
        };
        // 添加事件监听器
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        // 清理工作
        return ()=>{
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        currentSlide,
        carousel,
        query,
        a,
        Img
    ]);
    const [copy, setCopy] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const success = ()=>{
        messageInfo({
            type: "success",
            content: "Copied"
        });
    };
    const onChange = (param)=>{
        let { target: { value  }  } = param;
        setPhoneModel(value);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-[620px] Ssm:w-[100%] overflow-x-hidden overflow-auto h-[100%] mx-auto justify-between setup ".concat(data.fullScreen ? "grid xs:pb-[0px]" : "Smd:flex overflow-hidden xs:pb-[70px] h-[99%]"),
        children: [
            contextHolder,
            data.fullScreen && /*#__PURE__*/ _jsx(Icon, {
                onClick: ()=>{
                    data.setFullScreen(false);
                },
                icon: "0maki:cross",
                className: "absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
            }),
            /*#__PURE__*/ _jsxs("div", {
                onMouseEnter: ()=>{
                    setAutoplay(false), setA(0);
                },
                onMouseLeave: ()=>{
                    setAutoplay(true), setA(1);
                },
                className: "w-full text-black Ssm:w-[100%] mx-auto justify-between setup ".concat(data.fullScreen ? "grid mx-auto" : " Smd:flex Dsm:mt-[30px] justify-between"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[353px] ".concat(data.fullScreen ? "order-2 !w-[80%] mx-auto mt-[20px]" : "Dsm:w-[100%] Ssm:mx-auto"),
                        children: [
                            /*#__PURE__*/ _jsx(ConfigProvider, {
                                theme: {
                                    token: {
                                        // Seed Token，影响范围大
                                        colorPrimary: "#12D8AB"
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    className: "".concat(styles.box, " mb-[20px]"),
                                    options: options,
                                    onChange: onChange,
                                    value: phoneModel,
                                    optionType: "button",
                                    buttonStyle: "solid"
                                })
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-[24px] Dsm:text-[20px] pb-[10px] font-[600] Dsm:text-center  ".concat(data.fullScreen ? "" : ""),
                                children: "Key Steps to Watch For"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "".concat(data.fullScreen ? "pt-[20px]" : "Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]"),
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ _jsxs("div", {
                                        onClick: ()=>Handler(index),
                                        className: "text-[14px] cursor-pointer  ".concat(data.fullScreen ? "mt-[10px]" : " mt-[7px] Dsm:mt-[10px]"),
                                        children: [
                                            (index === 1 || index === 5 || index === 9) && /*#__PURE__*/ _jsxs("div", {
                                                className: "flex mt-[20px] mb-[5px] items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "w-[6px] h-[6px] min-w-[6px] rounded-full flex items-center justify-center -mt-[1px] bg-[#1C1C1E]"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "ml-1 w-[100%] flex items-center text-[13px]\n                        ",
                                                        children: [
                                                            index === 1 && /*#__PURE__*/ _jsxs("div", {
                                                                children: [
                                                                    "Allow ",
                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                        children: "Settings > Accessibility"
                                                                    })
                                                                ]
                                                            }),
                                                            index === 5 && /*#__PURE__*/ _jsxs("div", {
                                                                children: [
                                                                    "If you can't turn it on at ",
                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                        children: "Accessibility"
                                                                    }),
                                                                    ", you need to turn on the",
                                                                    " ",
                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                        children: "Allow restricted settings"
                                                                    })
                                                                ]
                                                            }),
                                                            index === 9 && /*#__PURE__*/ _jsx(_Fragment, {
                                                                children: "Authorize geolocation for the Update service with permission always allowed:"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center ".concat(index === 0 ? "" : "pl-[20px]"),
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "w-[6px] h-[6px] min-w-[6px] rounded-full ".concat(currentSlide === index && "bg-[#1C1C1E]", " flex justify-center items-center"),
                                                        children: /*#__PURE__*/ _jsx("p", {
                                                            className: "w-[4px] h-[4px] min-w-[4px] ".concat(index === 0 && "w-[6px] h-[6px] min-w-[6px]", " rounded-full flex items-center justify-center -mt-[1px] bg-[#1C1C1E]")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "ml-1 w-[100%] flex items-center  ".concat(data.fullScreen ? "text-[13px]" : "text-[13px]"),
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.title
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ".concat(data.fullScreen ? "order-1 mx-auto" : "Ssm:hidden"),
                        children: [
                            /*#__PURE__*/ _jsx(Carousel, {
                                autoplay: autoplay,
                                className: "flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]",
                                ref: imgToggle,
                                cancelable: false,
                                afterChange: (index)=>{},
                                beforeChange: (index, index2)=>{
                                    setImg(index2);
                                },
                                children: carousel.map((item, index)=>{
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "rounded-[15px]",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            alt: "img",
                                            width: 100,
                                            height: 100,
                                            src: item.src,
                                            className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-center mt-[7px]",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        onClick: ()=>{
                                            if (currentSlide <= 0) {
                                                setCarousel(step[step.length - 1].img), setcurrentSlide(step.length - 1), setImg(step.length - 1), imgToggle.current.goTo(step.length - 1);
                                            } else {
                                                setCarousel(step[currentSlide - 1].img), setcurrentSlide(currentSlide - 1), setImg(currentSlide - 1), imgToggle.current.goTo(currentSlide - 1);
                                            }
                                        },
                                        className: "text-[#12D8AB] text-[30px] font-[600] cursor-pointer select-none",
                                        children: "<"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "border-[1px] border-[#12D8AB] w-[18px] h-[12px] cursor-pointer rounded-[15px] ml-[25px] bg-[#12D8AB]"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        onClick: ()=>{
                                            if (currentSlide >= step.length - 1) {
                                                setCarousel(step[0].img), setcurrentSlide(0), setImg(0), imgToggle.current.goTo(0);
                                            } else {
                                                setCarousel(step[currentSlide + 1].img), setcurrentSlide(currentSlide + 1), setImg(currentSlide + 1), imgToggle.current.goTo(currentSlide + 1);
                                            }
                                        },
                                        className: "text-[#12D8AB] text-[30px] font-[600] cursor-pointer rounded-[15px] ml-[25px] select-none",
                                        children: ">"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "absolute -left-[4px] top-[55px]",
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/android/1.svg",
                                        className: "w-[5px] h-[24px]",
                                        width: 100,
                                        height: 100,
                                        alt: "img"
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/android/1.svg",
                                        className: "w-[5px] h-[24px] mt-4",
                                        width: 100,
                                        height: 100,
                                        alt: "img"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "Smd:hidden ".concat(data.fullScreen && "hidden"),
                onClick: ()=>data.setFullScreen(true),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: "/images/android/watch.png",
                    width: 100,
                    height: 100,
                    alt: "watch",
                    className: "mx-auto w-[150px] mt-[20px]"
                })
            })
        ]
    });
}
/* harmony default export */ var PermissionDescription = ((/* unused pure expression or super */ null && (PermissionDescription_One)));

// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
;// CONCATENATED MODULE: ./src/components/android-step/newProgress1.js



const NewProgress3 = (param)=>{
    let { setPhoneType , setNowPage  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    // 选择其他品牌手机时发送邮件
    const selectOtherPhone = async ()=>{
        try {
            var ref;
            //获取用户邮箱
            const email = (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.email;
            // 调用发邮件接口(code:0 成功)
            await (0,android/* localPhoneSendEmailandroid */.lm)({
                email
            });
            setNowPage(2);
            setPhoneType("other");
        } catch (e) {
            ;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-[22px] flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[24px] text-center text-[#2B2D33] font-[600] leading-[32px] mb-[60px] lg:text-nowrap",
                children: t("Select the brand of monitored phone")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-[213px] h-[76px] px-[16px] mb-4 text-[18px] text-[#222222] font-[400] leading-[24px] [border:1px_solid_#D3D6DE] rounded-[10px] break-all hover:[background:linear-gradient(to_bottom,#ECF3FE,#FDFEFF)] hover:border-[#0481FF] text-center",
                onClick: ()=>{
                    setNowPage(2);
                    setPhoneType("samsung");
                },
                children: t("Samsung")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-[213px] h-[76px] px-[16px] mb-4 text-[18px] text-[#222222] font-[400] leading-[24px] [border:1px_solid_#D3D6DE] rounded-[10px] break-all hover:[background:linear-gradient(to_bottom,#ECF3FE,#FDFEFF)] hover:border-[#0481FF] text-center",
                onClick: ()=>{
                    setNowPage(2);
                    setPhoneType("xiaomi");
                },
                children: t("Xiaomi")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "w-[213px] h-[76px] px-[16px] text-[18px] text-[#222222] font-[400] leading-[27px] [border:1px_solid_#D3D6DE] rounded-[10px] break-all hover:[background:linear-gradient(to_bottom,#ECF3FE,#FDFEFF)] hover:border-[#0481FF] text-center",
                onClick: ()=>{
                    setNowPage(2);
                    setPhoneType("other");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block",
                        children: t("othersText1")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("othersText2")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var newProgress1 = (NewProgress3);

;// CONCATENATED MODULE: ./src/components/android-step/newProgress2.js


const NewProgress2 = (param)=>{
    let { nowPage  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    return(// 新ui
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-[22px] flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[24px] text-center text-[#2B2D33] font-[600] leading-[32px] mb-[60px]",
                children: t("Configuration Process")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-[20px] h-[20px] text-[14px] font-[500] leading-[18px] flex justify-center items-center mr-2 ".concat(nowPage === 2 ? "bg-[#2A99FF] text-[#FFFFFF]" : "text-[#222222]", " rounded-[10px]"),
                                children: "1."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] leading-[22px] ".concat(nowPage === 2 ? "font-[600]" : "font-[400]"),
                                children: t("Install app on target phone")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex items-start mt-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-[20px] h-[20px] text-[14px] font-[500] leading-[18px] flex justify-center items-center mr-2 ".concat(nowPage === 5 ? "bg-[#2A99FF] text-[#FFFFFF]" : "text-[#222222]", " rounded-[10px]"),
                                children: "2."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] leading-[22px] ".concat(nowPage === 5 ? "font-[600]" : "font-[400]"),
                                children: t("Configure in the target phone")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex items-start mt-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-[20px] h-[20px] text-[14px] font-[500] leading-[18px] flex justify-center items-center mr-2 ".concat(nowPage === 12 ? "bg-[#2A99FF] text-[#FFFFFF]" : "text-[#222222]", " rounded-[10px]"),
                                children: "3."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] leading-[22px] ".concat(nowPage === 12 ? "font-[600]" : "font-[400]"),
                                children: t("Verify successful")
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var newProgress2 = (NewProgress2);

;// CONCATENATED MODULE: ./src/components/android-step/newProgress3.js






const newProgress3_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const newProgress3_NewProgress3 = (param)=>{
    let { nowPage  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const [copy, setCopy] = (0,react.useState)(false);
    const success = ()=>{
        (0,Message/* messageInfo */.B)({
            type: "success",
            content: "Copied"
        });
    };
    const StepProgress = (param)=>{
        let { current =2 , total =6  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newProgress3_ScrollDiv, {
                className: "!h-[calc(var(--vh2)*100-194px)] pb-2 mx-[30px] flex flex-col items-center overflow-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-[24px] smj:text-[20px] text-center text-[#2B2D33] font-[600] leading-[32px] mb-[30px]",
                            children: t("Download Msafely installer on the target phone")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/bind/qrcode-apk-test.png" || 0,
                            width: 180,
                            height: 78,
                            className: "w-[180px] h-auto mb-[12px]",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "text-[14px] font-[400] leading-[21px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "flex items-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                t("On the device you want to monitor"),
                                                ":"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-start mt-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "1.\xa0\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                t("Type"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: "msafely.net/download "
                                                }),
                                                " ",
                                                t("into the browser address bar or scan the QR code to go to the download page")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-start mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "2.\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                t("Slide the bar from left to right to begin download"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: t("Download anyway")
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-start mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "3.\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                t("Once downloaded tap"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: t("Open")
                                                }),
                                                ". ",
                                                t("If you see a warning go to Settings find your browser app and enable Install unknown apps Then return to your browser to install")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-start mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "4.\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                t("After installing tap"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: t("Open")
                                                }),
                                                ". ",
                                                t("If you see a security pop-up tap"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: t("IGNORE")
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var newProgress3 = (newProgress3_NewProgress3);

;// CONCATENATED MODULE: ./src/components/android-step/newProgress4.js





const newProgress4_ScrollDiv = (0,styled/* default */.ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const NewProgress4 = (param)=>{
    let { phoneType , nowPage , Code  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const [showData, setShowData] = (0,react.useState)([]);
    const dom = (0,react.useRef)(null);
    // 其他品牌手机图片文案
    const otherArr = [
        [
            {
                img1: "/images/bind/other/config1-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 166
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Lets Start and Install in sequence")
            },
            {
                img1: "/images/bind/other/config1-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 100
                },
                imgSize2: {},
                text: t("Click Setting on the pop-up")
            },
            {
                img1: "/images/bind/other/config1-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 90
                },
                imgSize2: {},
                text: t("Tap the button set to Allow")
            },
            {
                img1: "/images/bind/other/config1-4.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 90
                },
                imgSize2: {},
                text: t("Click Install on the pop-up")
            }
        ],
        [
            {
                img1: "/images/bind/other/config2-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 98
                },
                imgSize2: {},
                text: t("Click OK on the pop-up")
            },
            {
                img1: "/images/bind/other/config2-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 130
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/other/config2-3.jpg",
                img2: "/images/bind/other/config2-4.jpg",
                imgSize1: {
                    w: 180,
                    h: 130
                },
                imgSize2: {
                    w: 180,
                    h: 98
                },
                text: t("Scroll until see Update service then click and set to Allow")
            }
        ],
        [
            {
                img1: "/images/bind/other/config3-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 128
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/other/config3-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 146
                },
                imgSize2: {},
                text: t("Select Update service in Accessibility")
            },
            {
                img1: "/images/bind/other/config3-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 205
                },
                imgSize2: {},
                text: t("Tap the button then select Allow")
            }
        ],
        [
            {
                img1: "/images/bind/other/config4-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 192
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Choose Allow on all pop-ups")
            }
        ],
        [
            {
                img1: "/images/bind/other/config5-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 135
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/other/config5-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 160
                },
                imgSize2: {},
                text: t("Select Permissions in this page")
            },
            {
                img1: "/images/bind/other/config5-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 160
                },
                imgSize2: {},
                text: t("Select Location and set to Allow all the time")
            }
        ],
        [
            {
                img1: "/images/bind/other/config6-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 163
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/other/config6-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 307
                },
                imgSize2: {},
                text: t("Select Activate this device admin app")
            }
        ]
    ];
    // 三星手机图片文案
    const samsungArr = [
        [
            {
                img1: "/images/bind/samsung/config1-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 200
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Lets Start and Install in sequence")
            },
            {
                img1: "/images/bind/samsung/config1-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 120
                },
                imgSize2: {},
                text: t("Click Setting on the pop-up")
            },
            {
                img1: "/images/bind/samsung/config1-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 100
                },
                imgSize2: {},
                text: t("Scroll until fine Update service set to Allow and then click Install in pop-up")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Then go back Continue page")
            }
        ],
        [
            {
                img1: "/images/bind/samsung/config2-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 178
                },
                imgSize2: {},
                text: t("Click ok to unstall the installation package")
            },
            {
                img1: "/images/bind/samsung/config2-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 109
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/samsung/config2-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 130
                },
                imgSize2: {},
                text: t("Scroll until see Update service then click and set to Allow")
            }
        ],
        [
            {
                img1: "/images/bind/samsung/config3-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 103
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/samsung/config3-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 126
                },
                imgSize2: {},
                text: t("Select Installed apps in Accessibility")
            },
            {
                img1: "/images/bind/samsung/config3-3.jpg",
                img2: "/images/bind/samsung/config3-4.jpg",
                imgSize1: {
                    w: 180,
                    h: 86.67
                },
                imgSize2: {
                    w: 180,
                    h: 159
                },
                text: t("Select Update service then set off to on And click Allow in pop-up")
            }
        ],
        [
            {
                img1: "/images/bind/samsung/config4-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 192
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Choose Allow on all pop-ups")
            }
        ],
        [
            {
                img1: "/images/bind/samsung/config5-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 135
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/samsung/config5-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 150
                },
                imgSize2: {},
                text: t("Select Permissions in this page")
            },
            {
                img1: "/images/bind/samsung/config5-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 160
                },
                imgSize2: {},
                text: t("Select Location and set to Allow all the time")
            }
        ],
        [
            {
                img1: "/images/bind/samsung/config6-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 163
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/samsung/config6-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 170
                },
                imgSize2: {},
                text: t("Select Activate in this page")
            }
        ]
    ];
    // 小米手机图片文案
    const xiaomiArr = [
        [
            {
                img1: "/images/bind/xiaomi/config1-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 120
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Lets Start and Install in sequence")
            },
            {
                img1: "/images/bind/xiaomi/config1-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 75
                },
                imgSize2: {},
                text: t("Click Setting on the pop-up")
            },
            {
                img1: "/images/bind/xiaomi/config1-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 80
                },
                imgSize2: {},
                text: t("Tap the button set to Allow")
            },
            {
                img1: "/images/bind/xiaomi/config1-4.jpg",
                img2: "/images/bind/xiaomi/config1-5.jpg",
                imgSize1: {
                    w: 180,
                    h: 54
                },
                imgSize2: {
                    w: 180,
                    h: 65
                },
                text: t("Click Ok after 10 seconds then select Install on the pop-up")
            }
        ],
        [
            {
                img1: "/images/bind/xiaomi/config2-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 90
                },
                imgSize2: {},
                text: t("Click ok to unstall the installation package")
            },
            {
                img1: "/images/bind/xiaomi/config2-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 121.11
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/xiaomi/config2-3.jpg",
                img2: "/images/bind/xiaomi/config2-4.jpg",
                imgSize1: {
                    w: 180,
                    h: 94
                },
                imgSize2: {
                    w: 180,
                    h: 100
                },
                text: t("Scroll until see Update service then click and set to Allow")
            }
        ],
        [
            {
                img1: "/images/bind/xiaomi/config3-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 110
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/xiaomi/config3-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 64
                },
                imgSize2: {},
                text: t("Select Downloaded apps")
            },
            {
                img1: "/images/bind/xiaomi/config3-3.jpg",
                img2: "/images/bind/xiaomi/config3-4.jpg",
                img3: "/images/bind/xiaomi/config3-5.jpg",
                imgSize1: {
                    w: 180,
                    h: 100
                },
                imgSize2: {
                    w: 180,
                    h: 90
                },
                imgSize3: {
                    w: 180,
                    h: 70
                },
                text: t("Click Update service set off to on And Click OK after 10 secnds")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Then go back to Continue page")
            }
        ],
        [
            {
                img1: "/images/bind/xiaomi/config4-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 192
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Choose Allow on all pop-ups")
            }
        ],
        [
            {
                img1: "/images/bind/xiaomi/config5-1.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 122.73
                },
                imgSize2: {},
                text: t("Follow the guidelines in the app click Continue")
            },
            {
                img1: "/images/bind/xiaomi/config5-2.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 185
                },
                imgSize2: {},
                text: t("Select App Permissions in this page")
            },
            {
                img1: "/images/bind/xiaomi/config5-3.jpg",
                img2: "",
                imgSize1: {
                    w: 180,
                    h: 161
                },
                imgSize2: {},
                text: t("Select Location and set to Allow all the time")
            }
        ],
        [
            {
                img1: "/images/bind/xiaomi/config6-1.jpg",
                img2: "/images/bind/xiaomi/config6-2.jpg",
                img3: "/images/bind/xiaomi/config6-3.jpg",
                img4: "/images/bind/xiaomi/config6-4.jpg",
                imgSize1: {
                    w: 180,
                    h: 90
                },
                imgSize2: {
                    w: 180,
                    h: 188
                },
                imgSize3: {
                    w: 180,
                    h: 100
                },
                imgSize4: {
                    w: 180,
                    h: 90
                },
                text: t("Click Continue and select Activate this device admin app Then go back Continue page and click Continue again")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Repeat this operation three times selecting No restrictions then tap Update service to on in sequence")
            },
            {
                img1: "",
                img2: "",
                imgSize1: {},
                imgSize2: {},
                text: t("Then go back to Continue page and click it again")
            }
        ]
    ];
    (0,react.useEffect)(()=>{
        if (nowPage !== 12) {
            switch(phoneType){
                case "other":
                    setShowData(otherArr[nowPage - 6]);
                    break;
                case "samsung":
                    setShowData(samsungArr[nowPage - 6]);
                    break;
                case "xiaomi":
                    setShowData(xiaomiArr[nowPage - 6]);
                    break;
            }
        }
    }, [
        phoneType,
        nowPage
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = dom.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            top: 0,
            behavior: "smooth" // 平滑滚动
        });
    }, [
        nowPage
    ]);
    const StepProgress = (param)=>{
        let { current =3 , total =6  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newProgress4_ScrollDiv, {
                ref: dom,
                className: "!h-[calc(var(--vh2)*100-180px)] pb-2 mx-[30px] flex flex-col items-center overflow-auto",
                children: nowPage !== 12 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col items-center Mlg:mt-[28px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: showData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "flex flex-col items-center justify-center",
                                children: [
                                    item.img1 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img1,
                                        width: item.imgSize1.w,
                                        height: item.imgSize1.h,
                                        alt: "img1",
                                        className: "mt-[12px] mb-[10px] rounded-[18px]",
                                        style: {
                                            width: "".concat(item.imgSize1.w, "px"),
                                            height: "auto"
                                        }
                                    }),
                                    item.img2 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img2,
                                        width: item.imgSize2.w,
                                        height: item.imgSize2.h,
                                        alt: "img2",
                                        className: "mb-[10px] rounded-[18px]",
                                        style: {
                                            width: "".concat(item.imgSize2.w, "px"),
                                            height: "auto"
                                        }
                                    }),
                                    item.img3 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img3,
                                        width: item.imgSize3.w,
                                        height: item.imgSize3.h,
                                        alt: "img3",
                                        className: "mb-[10px] rounded-[18px]",
                                        style: {
                                            width: "".concat(item.imgSize3.w, "px"),
                                            height: "auto"
                                        }
                                    }),
                                    item.img4 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.img4,
                                        width: item.imgSize4.w,
                                        height: item.imgSize4.h,
                                        alt: "img4",
                                        className: "mb-[10px] rounded-[18px]",
                                        style: {
                                            width: "".concat(item.imgSize4.w, "px"),
                                            height: "auto"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-start items-start ".concat(item.img1 === "" && item.img2 === "" ? "mt-4" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "w-[20px] min-w-[20px] h-[20px] text-[14px] ".concat(index === 0 ? "bg-[#2A99FF] text-[#FFFFFF]" : "", " font-[500] leading-[18px] flex justify-center items-center mr-2 rounded-[10px]"),
                                                children: [
                                                    index + 1,
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[16px] font-[400] leading-[24px]",
                                                dangerouslySetInnerHTML: {
                                                    __html: item.text
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[24px] Mlg:text-[20px] text-black font-[700] leading-[36px] Mlg:leading-[30px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Install Msafely on the target phone")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "w-full mt-3 text-[#222222] text-[14px] leading-[21px] text-start",
                            children: t("Enter the registration code in the final step of the Msafely app")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[42px] text-[#454CFF] font-[600] leading-[60px] mt-[6px]",
                            children: Code
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/bind/other/step1.webp",
                            width: 230,
                            height: 360,
                            alt: "img1",
                            className: "smj:w-[230px] w-[345px] h-auto mt-[32px]"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var newProgress4 = (NewProgress4);

;// CONCATENATED MODULE: ./src/components/android-step/ready.js





const Preparation = (data)=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const [checked, setChecked] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Mlg:px-[24px] w-[435px] mx-auto smj:h-[calc(100vh-78px)] smj:pb-[100px] overflow-y-auto smj:w-full flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[#282938] Mlg:mt-[14px] text-center flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[24px] leading-[36px] font-semibold",
                        children: t("Before you begin")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[18px] leading-[26px] font-medium mt-[10px]",
                        children: t("Preparation for successful Connection")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[374px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/warn.svg",
                        className: "flex w-[24px] h-[24px] mr-[12px]",
                        alt: "img",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]",
                        children: [
                            t("Please note that all information and devices mentioned below refer to the"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t("target device")
                            }),
                            " ",
                            t("you wish to monitor not your own phone")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Mlg:mt-[16px] mt-[32px] flex flex-col justify-start gap-y-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-[600]",
                                children: t("Target device")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("At least 50MB of free storage")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("Sufficient battery charge recommended over 50")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("Stable internet connection")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("15 minutes of uninterrupted time for continuous access to the target device")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mt-[86px] smj:mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: ()=>setChecked(!checked),
                        className: "appearance-none w-[16px] h-[16px] border border-[#165DFF] rounded-[2px] cursor-pointer transition-all duration-10 checked:bg-[#165DFF] checked:border-[#165DFF] checked:bg-[url('/image/agree.svg')] checked:bg-no-repeat checked:bg-center checked:bg-[length:10px_10px] focus:outline-none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "ml-[6px] text-[#282938] text-[12px] leading-[20px]",
                        children: t("I have all the above items ready")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[266px] Mlg:w-full flex justify-center items-center mt-[16px] smj:pb-7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    disabled: !checked,
                    className: "w-full h-[60px] Mlg:h-[50px] mx-auto text-[#282938] text-[16px] font-[600] rounded-[41px] flex justify-center items-center bg-[#FFCF55]\n                      ".concat(!checked ? "opacity-30 cursor-not-allowed" : "cursor-pointer"),
                    onClick: ()=>checked && data.setIsAgree(false),
                    children: t("Start to connect")
                })
            })
        ]
    });
};
/* harmony default export */ var ready = (Preparation);

// EXTERNAL MODULE: ./src/utils/chooseDeviceRedirect.js
var chooseDeviceRedirect = __webpack_require__(99518);
// EXTERNAL MODULE: ./src/utils/refreshSidebarDevices.js
var refreshSidebarDevices = __webpack_require__(66512);
;// CONCATENATED MODULE: ./src/pages/android/local/setup/index.js











// ** Icon Imports
















function Index() {
    const left = "<";
    const right = ">";
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const [setupBlocked, setSetupBlocked] = (0,react.useState)(true);
    //移动端全屏
    const [fullScreen, setFullScreen] = (0,react.useState)(false);
    //记录当前步骤
    const [ID, setID] = (0,react.useState)(1);
    const router = (0,next_router.useRouter)();
    //验证码
    const [Code, setCode] = (0,react.useState)("");
    //蒙版
    const [Open, setOpen] = (0,react.useState)(false);
    //弹窗
    const [modalOpen, setModalOpen] = (0,react.useState)(false);
    const [modalText, setModalText] = (0,react.useState)(false);
    const [clickCount, setClickCount] = (0,react.useState)(0);
    const [isDisabled, setIsDisabled] = (0,react.useState)(false);
    const [text, setText] = (0,react.useState)(t("Target device binding was not successful Please enter the registration code on the target device"));
    // 当前页面
    const [nowPage, setNowPage] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (clickCount === 3) {
            setIsDisabled(true);
            const timer = setTimeout(()=>{
                setClickCount(0);
                setModalOpen(false);
            }, 15000) //15秒后清除限制
            ;
            return ()=>clearTimeout(timer);
        }
    }, [
        clickCount
    ]);
    const closeModal = ()=>{
        setModalOpen(false);
        setModalText(false);
    };
    //注册码
    (0,react.useEffect)(()=>{
        if (!router.isReady) return;
        let active = true;
        const GetCode = async ()=>{
            try {
                const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
                const result = orderId ? await (0,android/* getCode */.Cq)({
                    params: {
                        id: orderId
                    }
                }) : await (0,android/* getCode */.Cq)();
                if (active) setCode(result.data);
            } catch (err) {
                ;
            }
        };
        GetCode();
        return ()=>{
            active = false;
        };
    }, [
        router.asPath,
        router.isReady
    ]);
    const NextHandler = async ()=>{
        if (ID !== 4) {
            setID(ID + 1);
        } else {
            //到达第三步
            //点击小于三次
            if (clickCount < 3) {
                setClickCount(clickCount + 1);
                setOpen(!Open);
                const res = await (0,android/* CheckCode */.ds)({
                    code: Code
                });
                try {
                    if (res.userDevice) {
                        setID(ID + 1);
                        // 绑定成功后刷新侧栏设备列表（SpyX 版没有这一步，Msafely 保留）
                        (0,refreshSidebarDevices/* refreshSidebarDevices */.Ii)();
                    } else {
                        setText(t("Target device binding was not successful (Please enter the registration code on the target device.)"));
                        setModalOpen(true);
                        setTimeout(()=>{
                            setModalOpen(false);
                        }, 5000);
                    }
                    setOpen(false);
                } catch (err) {
                    ;
                }
            } else {
                //操作频繁
                setText(t("Frequent operations, try again after 15 seconds"));
                setModalOpen(true);
            }
        }
    };
    const startMonitoring = async ()=>{
        if (nowPage === 12) {
            bindTracking("startMonitoring");
        }
        if (clickCount < 3) {
            setClickCount(clickCount + 1);
            setOpen(!Open);
            const res = await (0,android/* CheckCode */.ds)({
                code: Code
            });
            try {
                if (res.userDevice) {
                    setNowPage(nowPage + 1);
                    bindTracking("clearTracesGuideView");
                } else {
                    setText(t("Please complete the final step in the app by entering the registration code"));
                    setModalOpen(true);
                    setModalText(true);
                    setTimeout(()=>{
                        setModalOpen(false);
                        setModalText(false);
                    }, 5000);
                }
                setOpen(false);
            } catch (err) {
                ;
            }
        } else {
            //操作频繁
            setText(t("Frequent operations try again after 15 seconds"));
            setModalOpen(true);
        }
    };
    // 选择的手机品牌
    const [phoneType, setPhoneType] = (0,react.useState)("");
    // 埋点
    const bindTracking = async (type)=>{
        const typeMap = {
            0: "webDisableProtectView",
            3: "downloadGuideView",
            12: "regCodeDisplayView",
            "startMonitoring": "regCodeNextClick",
            "clearTracesGuideView": "clearTracesGuideView"
        };
        const action = typeMap[type];
        if (action) {}
    };
    (0,react.useEffect)(()=>{
        bindTracking(nowPage);
    }, [
        nowPage
    ]);
    const [isAgree, setIsAgree] = (0,react.useState)(false) // 是否显示绑定设备前的准备工作页面
    ;
    (0,react.useEffect)(()=>{
        const guard = (0,resolveCurrentOrderId/* guardAppSetupOrderId */.Bq)(window.location.search);
        if (guard.blocked) {
            setSetupBlocked(true);
            return;
        }
        setSetupBlocked(false);
        if (guard.orderId) return;
        const init = async ()=>{
            const result = await (0,login.getNotBindOrder)();
            await (0,chooseDeviceRedirect/* redirectIfShouldBuyPackage */.og)(result);
        };
        init();
    }, []);
    if (setupBlocked) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[620px] lg:mx-auto !h-[calc(var(--vh2)*100-60px)] font-[Poppins] pt-[60px] Mlg:pt-4 ".concat(nowPage > 12 ? "max-w-full relative" : ""),
                children: [
                    isAgree && /*#__PURE__*/ (0,jsx_runtime.jsx)(ready, {
                        setIsAgree: setIsAgree
                    }),
                    isAgree || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            nowPage === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(one, {
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen
                            }),
                            nowPage === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(newProgress1, {
                                setPhoneType: setPhoneType,
                                setNowPage: setNowPage
                            }),
                            [
                                2,
                                5
                            ].includes(nowPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(newProgress2, {
                                nowPage: nowPage
                            }),
                            [
                                3,
                                4
                            ].includes(nowPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(newProgress3, {
                                nowPage: nowPage
                            }),
                            [
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12
                            ].includes(nowPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(newProgress4, {
                                phoneType: phoneType,
                                nowPage: nowPage,
                                Code: Code
                            }),
                            nowPage === 13 && /*#__PURE__*/ (0,jsx_runtime.jsx)(four, {
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen,
                                Code: Code,
                                nowPage: nowPage,
                                setNowPage: setNowPage,
                                startMonitoring: startMonitoring
                            }),
                            nowPage === 14 && /*#__PURE__*/ (0,jsx_runtime.jsx)(five, {
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen,
                                Code: Code,
                                nowPage: nowPage,
                                setNowPage: setNowPage,
                                startMonitoring: startMonitoring
                            }),
                            nowPage === 15 && /*#__PURE__*/ (0,jsx_runtime.jsx)(six, {
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen,
                                Code: Code,
                                nowPage: nowPage,
                                setNowPage: setNowPage,
                                startMonitoring: startMonitoring
                            }),
                            nowPage === 16 && /*#__PURE__*/ (0,jsx_runtime.jsx)(seven, {
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen,
                                Code: Code,
                                nowPage: nowPage,
                                setNowPage: setNowPage,
                                startMonitoring: startMonitoring
                            }),
                            nowPage === 17 && /*#__PURE__*/ (0,jsx_runtime.jsx)(eight, {
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen,
                                Code: Code,
                                nowPage: nowPage,
                                setNowPage: setNowPage,
                                startMonitoring: startMonitoring
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop/* default */.Z, {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                open: modalOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-center",
                    children: modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-[92%] fixed top-1/2 left-1/2 max-w-[480px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-4xl rounded-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>closeModal(false),
                                className: "flex justify-end absolute right-4 top-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "maki:cross",
                                    className: "text-black/20 w-[20px] h-[20px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-[50px] py-[40px] flex flex-col items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "material-symbols:error",
                                        className: "text-red-600 w-[25px] h-[25px]"
                                    }),
                                    modalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[20px] font-[600] text-black mt-4 w-full text-center",
                                        children: t("Device not connected successfully")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-black text-center w-full mt-4 text-[16px]",
                                        children: text
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop/* default */.Z, {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                open: Open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    color: "inherit"
                })
            }),
            isAgree || /*#__PURE__*/ (0,jsx_runtime.jsx)(newFooter, {
                nowPage: nowPage,
                setNowPage: setNowPage,
                startMonitoring: startMonitoring,
                showFlag: nowPage > 12,
                setIsAgree: setIsAgree
            })
        ]
    });
}
/* harmony default export */ var setup = (Index);


/***/ }),

/***/ 61502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_images_apps_7_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47234);
/* harmony import */ var _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47206);
/* harmony import */ var _public_images_apps_11_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84538);
/* harmony import */ var _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57614);
/* harmony import */ var _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49967);
/* harmony import */ var _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4201);
/* harmony import */ var _public_images_apps_15_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79711);
/* harmony import */ var _public_images_apps_16_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69489);
/* harmony import */ var _public_images_apps_19_webp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _public_images_apps_21_webp__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88101);
/* harmony import */ var _public_images_apps_22_webp__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95598);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66242);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1954);
















function index() {
    const APPLICATIONS = [
        {
            id: 1,
            title: "Telegram",
            img: _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            time: "12:45 PM",
            size: "43s"
        },
        {
            id: 25,
            title: "Safari",
            img: _public_images_apps_19_webp__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
            time: "10:18 PM",
            size: "23s"
        },
        {
            id: 26,
            title: "Safari",
            img: _public_images_apps_19_webp__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
            time: "10:10 PM",
            size: "52s"
        },
        {
            id: 27,
            title: "Music",
            img: _public_images_apps_21_webp__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
            time: "09:10 PM",
            size: "33s"
        },
        {
            id: 2,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "12:35 PM",
            size: "10s"
        },
        {
            id: 3,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "12:35 PM",
            size: "15s"
        },
        {
            id: 29,
            img: _public_images_apps_22_webp__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
            title: "Shadowrocket",
            time: "12:20 PM",
            size: "12m 3s"
        },
        {
            id: 4,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "12:34 PM",
            size: "59s"
        },
        {
            id: 5,
            title: "Twitter",
            img: _public_images_apps_11_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            time: "12:34 PM",
            size: "13s"
        },
        {
            id: 6,
            title: "Telegram",
            img: _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            time: "12:22 PM",
            size: "43s"
        },
        {
            id: 7,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "12:10 PM",
            size: "2m 3s"
        },
        {
            id: 8,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "12:01 PM",
            size: "6m 3s"
        },
        {
            id: 9,
            title: "Gmail",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "11:13 PM",
            size: "30s"
        },
        {
            id: 10,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "11:10 PM",
            size: "54s"
        },
        {
            id: 11,
            title: "Twitter",
            img: _public_images_apps_11_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            time: "10:42 PM",
            size: "14s"
        },
        {
            id: 12,
            title: "Telegram",
            img: _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            time: "9:19 PM",
            size: "8m 6s"
        },
        {
            id: 13,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "9:01 PM",
            size: "6m 39s"
        },
        {
            id: 14,
            title: "Gmail",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "8:13 PM",
            size: "30s"
        },
        {
            id: 15,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:55 PM",
            size: "2m 43s"
        },
        {
            id: 16,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:40 PM",
            size: "2m 3s"
        },
        {
            id: 17,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:30 PM",
            size: "1m 3s"
        },
        {
            id: 18,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:22 PM",
            size: "33s"
        },
        {
            id: 19,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:18 PM",
            size: "1m 2s"
        },
        {
            id: 20,
            title: "Chrome Browser",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "11:01 PM",
            size: "5m 3s"
        },
        {
            id: 21,
            title: "Chrome Browser",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "10:30 PM",
            size: "2m 3s"
        },
        {
            id: 22,
            title: "Facebook",
            img: _public_images_apps_15_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            time: "12:10 PM",
            size: "43s"
        },
        {
            id: 23,
            title: "Chrome Browser",
            img: _public_images_apps_16_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
            time: "12:13 PM",
            size: "2m 32s"
        },
        {
            id: 24,
            title: "Chrome Browser",
            img: _public_images_apps_16_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
            time: "10:20 PM",
            size: "2m 3s"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            class: "bg-[#f5f6fa] p-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "md:w-2/3 sm:w-11/12 mx-auto bg-white rounded-lg",
                children: APPLICATIONS.map((app)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex h-[70px] items-center justify-between w-11/12 mx-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            src: app.img,
                                            alt: "img",
                                            className: "w-[35px] h-[35px] rounded-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "ml-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "font-semibold text-opacity-50 text-black",
                                                children: app.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[13px] text-opacity-60 text-black",
                                                children: app.time
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid justify-items-end",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-[0.875rem] font-medium text-black text-opacity-60",
                                        children: app.size
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .JO, {
                                        icon: "mdi:ellipsis-horizontal"
                                    })
                                ]
                            })
                        ]
                    }, app.id);
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 66512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ii": function() { return /* binding */ refreshSidebarDevices; },
/* harmony export */   "MD": function() { return /* binding */ SIDEBAR_DEVICES_REFRESH_EVENT; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);

/** 侧栏设备 / 未绑订单刷新事件（Equipment / AndroidEquipment 监听） */ const SIDEBAR_DEVICES_REFRESH_EVENT = "sidebarDevicesRefresh";
/**
 * 绑定完成后刷新侧栏：
 * 1. 重拉 getAllUserDevice 写入 allDeviceUser
 * 2. 广播事件，驱动侧栏再请求设备列表 + getNotBindOrder
 */ const refreshSidebarDevices = async ()=>{
    if (false) {}
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        localStorage.setItem("allDeviceUser", JSON.stringify(Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : []));
    } catch (e) {
        ;
    }
    window.dispatchEvent(new CustomEvent(SIDEBAR_DEVICES_REFRESH_EVENT));
    return {
        ok: true
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSidebarDevices)));


/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "cw": function() { return /* binding */ isGraceDevice; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定由 userEntryGate 负责（后端状态优先），这里不参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1954,1033,518,1664,1978,6659,2870,9774,2888,179], function() { return __webpack_exec__(62532); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);